import React from "react";
import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card, Divider, Badge } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import AddIcon from "@mui/icons-material/Add";
import { DataGrid } from "@mui/x-data-grid";
import SearchData from "../components/SearchData";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import ReplayIcon from "@mui/icons-material/Replay";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import moment, { now } from "moment";
import Alert from "@mui/material/Alert";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CardHeader from "@mui/material/CardHeader";
import { date } from "yup";
import { max } from "date-fns";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
export default function EditSaleOrderrOld() {
  const history = useHistory();
  let { id } = useParams();
  const data_params = { id: id };
  const [pdfFileGen, setPDFFile] = useState([]);
  const EmpId = localStorage.getItem("EmpId");
  //const SaleorderData
  const [SaleorderData, SetSaleorderData] = useState([]);
  const [payment_data, SetPayment_Data] = useState([]);
  //Table ContainerList
  const [dataContainerList, setDataContainerList] = useState([]);
  const [dataFilterContainerList, setDataFilterContainerList] = useState([]);
  const [uniqueContainerSizeHeader, setUniqueContainerSizeHeader] = useState(
    []
  );
  const [ladendate, setladens] = useState("");
  const [chooseText, setChooseText] = useState("");
  const [uniqueContainerSizeTotal, setUniqueContainerSizeTotal] = useState([]);
  const columnsContainerList = [
    // {
    //   field: "Status",
    //   headerName: "STATUS",
    //   width: 150,
    //   valueFormatter: ({ value }) => (value == 1 ? "INSTOCK" : "OUTSTOCK"),
    // },
    { field: "ContainerNo", headerName: "CONTAINER NO", width: 150 },
    { field: "Size", headerName: "SZ/TY", width: 180 },
    { field: "", headerName: "SEAL NO", width: 200 },
    { field: "Voyage", headerName: "VOYAGE", width: 200 },
    { field: "DateIn", headerName: "DATE IN", width: 150 },
  ];
  const columnsLog= [
    // {
    //   field: "Status",
    //   headerName: "STATUS",
    //   width: 150,
    //   valueFormatter: ({ value }) => (value == 1 ? "INSTOCK" : "OUTSTOCK"),
    // },
    { field: "ContainerNo", headerName: "CONTAINER NO", width: 150 },
    { field: "Size", headerName: "SZ/TY", width: 180 },
    { field: "", headerName: "SEAL NO", width: 200 },
    { field: "Voyage", headerName: "VOYAGE", width: 200 },
    { field: "DateIn", headerName: "DATE IN", width: 150 },
  ];
  //Global Value Fetch
  const [customer_id, setCustomer_id] = useState("");
  const [quotation_id, setQuotation_id] = useState("");
  const [customer_data, setCustomer_data] = useState([]);
  const [liners_data, setLiners_data] = useState([]);
  const [freight_forwarder_data, setFreight_forwarder_data] = useState([]);
  const [commodity_data, setCommodity_data] = useState([]);
  const [container_data, setContainer_data] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [depots_data, setDepots_data] = useState([]);
  const [terminal_data, setTerminal_data] = useState([]);
  const [quotation_fetch_data, setQuotation_fetch_data] = useState([]);
  const [transshipment_fetch_data, setTransshipment_fetch_data] = useState([]);
  const [terms_fetch_data, setTerms_fetch_data] = useState([]);
  const [polpod_fetch_data, setPolPod_fetch_data] = useState([]);
  const [country_fetch_data, setCountry_fetch_data] = useState([]);
  const [spFactory_fetch_Data, setspFactory_fetch_data] = useState([]);
  const [package_data, setPackage_data] = useState([]);
  const [statusSO_data, setStatusSo_data] = useState([]);
  const [statusSelect_data, setStatusSelect_data] = useState("");
  const [incoterm_data, setIncoterm_data] = useState([]);
  //dialog
  const [MT_CNTR_AT_CY_STL, setMT_CNTR_AT_CY_STL] = useState(false);
  const [STUFFING_PLAN, setSTUFFING_PLAN] = useState(false);
  const [LADEN_CNTR, setLADEN_CNTR] = useState(false);
  const [Dialog_Voy_Fetch, setDialog_Voy] = useState(false);
  const [getETAIn, setGetETAIn] = useState("");
  const [diremark, setDiremark] = useState(false);
  //mt_cntr_at data
  const [req_stl_truck, setReq_stel_truck] = useState("");
  const [voyage_no, setVoyage_no] = useState("");
  const [mt_eta, setMt_eta] = useState("");
  const [pickUpDate, setPickupDate] = useState("");
  const [MT_CNTR_AT_CY_STL_DATA, setMT_CNTR_AT_CY_STL_DATA] = useState([]);
  //STUFFING_PLAN
  const [spDate, setspDate] = useState("");
  const [spFactory, setspFactory] = useState("");
  const [spQty, setspQty] = useState("");
  const [containerId, setcontainerId] = useState("");
  const [spCancel, setspCancel] = useState("");
  const [plan_data, setPlanData] = useState([]);
  //LADEN CNTR
  const [laden_Choose, setLaden_Choose] = useState("");
  const [laden_voyNo, setLaden_voyNo] = useState("");
  const [laden_etdDate, setLaden_etdDate] = useState("");
  const [laden_data, setLadenData] = useState([]);
  //TextField Disable
  const [DetDemDisable, setDetDemDisable] = useState(false);
  const [ComDisable, setComDisable] = useState(false);
  //TagError
  const [datemt, setdatemt] = useState("");
  const [TagErrorData, setTagErrorData] = useState([]);
  const [refTagErrorId, setRefTagErrorID] = useState("");
  //const etdpol closingdate 1st
  const [com_caluateSelect, setCom_caluateSelect] = useState(false);
  //const voy fetch
  const [voy_fetch, setVoyFetch] = useState([]);
  const [voy_no_select, setVoySelect] = useState([]);
  const [voy_no_select_Out, setVoySelectOut] = useState([]);

  //const Log Status
  const [plandate, setdateplan] = useState("");
  const [log_data, setLogData] = useState([]);
  const [log_data_length, setLog_data_length] = useState(0);
  const [see_moreData, setSeemore_data] = useState(false);
  const [remarklog, setremarkLog] = useState("");
 

  const [closing_date, setClosingdate] = useState("");
  const [dateetd, setEtd] = useState("");
  //fileupload
  const [date1st, setdate1st] = useState("");

  const [FileData, setFileData] = useState([]);
  const [RemarkFile, setRemarkFile] = useState("");
  const [myFile, setMyFile] = useState([]);

  const Input = styled("input")({
    display: "none",
  });
  const printk = async () => {
    try {
      api
        .post("api/saleorder/detail/pdf", data_params)
        .then((respose) => {
          // console.log(respose);
          respose?.data.map((x) => {
            setPDFFile(x?.path);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  //Tab
  const [value, setValue] = useState("1");
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  const handleCloseremark = ()=>{
    setDiremark(false)
    setremarkLog('')
  }
  //fetch SaleOrder Data
  const getSaleOrder_Data = async () => {
    try {
      const data = await api
        .post("api/saleorder/detail", data_params)
        .then((response) => {
          [].concat(response.data).map((res) => {
            SetSaleorderData(res);
            setMT_CNTR_AT_CY_STL_DATA(res.mt);
            setPlanData(res.plan);
            setLadenData(res.laden);
            GetQuotation(res.CustomerId);
            setVoySelect(res.PickupVoyageNo);
            setStatusSelect_data(res.StatusSO);

            getContainerList_Data(res.SoId);

            if (res.FreePoLDem.length != "" || res.FreePoLDet.length != "") {
              setComDisable(true);
            }
            if (res.FreePoLCom.length != "") {
              setDetDemDisable(true);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  //fetch freight_forwarder
  const getPackage = async () => {
    try {
      const data = await api.get("api/master/package");
      // console.log(data.data.data);
      setPackage_data(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch freight_forwarder
  const getLogStatus = async () => {
    try {
      const data = await api.post("api/saleorder/detail/log", data_params);
      setLogData(data.data);
      // console.log(data);
      setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };
  const getMyFile = async () => {
    const params = {
      id: SaleorderData.SoNumber,
      uploadType: 2,
    };
    try {
      const data = await api.post("api/saleorder/file", params);
      setMyFile(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch inco
  const GetIncoTerms = async () => {
    try {
      const data = await api.get("api/inco/list");
      //   console.log(data.data);
      setIncoterm_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  const handleFileUpload = () => {
    let formData = new FormData();

    formData.append("fileUpload", FileData);
    formData.append("soId", SaleorderData.SoNumber);
    formData.append("uploadType", 2);

    formData.append("createId", EmpId);
    formData.append("remark", RemarkFile);

    // console.log(fileData);
    // console.log(formData);

    api
      .post("api/saleorder/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
          icon: "success",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire("สำเร็จ!", "เพิ่ม ไฟล์ สำเร็จ !", "success");
        });
        setFileData("");
        setRemarkFile("");
        getMyFile();

        // console.log(res);
      })
      .catch(() => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
          icon: "error",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire("ล้มเหลว!", "เพิ่ม ไฟล์ ไม่สำเร็จ !", "error");
        });
        setFileData("");
        setRemarkFile("");
        getMyFile();
      });
  };
  //fetch Payment Data
  const getPayment_Data = async (res) => {
    try {
      const obj_id = {
        id: res,
      };
      const payment_data = await api
        .post("api/saleorder/payment/detail", obj_id)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              SetPayment_Data(res);
              //   console.log(res);
            });
          }
        });
    } catch (e) {
      // setCustomer_data(payment_data);
      console.log(e);
    }
  };
  //fetch SO Data
  const changeStatus = async () => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: "คุณกำลังปรับเปลี่ยนสถานะ",
      text: "คุณกำลังปรับเปลี่ยนสถานะ ใช่หรือไม่",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่ !",
      cancelButtonText: "ไม่",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const obj_id = {
            id: id,
            status: statusSelect_data,
            modId: EmpId,
          };
          const payment_data = api
            .post("api/saleorder/change/status", obj_id)
            .then((response) => {
              const MySwal = withReactContent(Swal);

              MySwal.fire({
                icon: "success",
                didOpen: () => {
                  MySwal.clickConfirm();
                },
              }).then(() => {
                return MySwal.fire(
                  "สำเร็จ!",
                  "อัพเดทสถานะเรียบร้อย !",
                  "success"
                ).then((result) => {
                  if (result.isConfirmed) {
                    getSaleOrder_Data();
                  }
                });
              });
            });
        } catch (e) {
          // setCustomer_data(payment_data);
          console.log(e);
        }
      }
    });
  };

  //fetch ContainerList Data
  const getContainerList_Data = async (res) => {
    try {
      const obj_id = {
        id: res,
      };
      const data = await api.post("api/saleorder/container/booking", obj_id);
      setDataContainerList(data.data);
      setDataFilterContainerList(data.data);
      // console.log(data);

      const dataReduceSize = data.data.reduce(
        (prev, cur) => ({
          ...prev,
          [cur.Size]: (prev[cur.Size] || 0) + 1,
        }),

        {}
      );

      setUniqueContainerSizeTotal([dataReduceSize]);

      const newSizeArray = [];
      data.data.forEach((element) => {
        // console.log(element.Size);
        newSizeArray.push(element.Size);
      });

      setUniqueContainerSizeHeader([...new Set(newSizeArray)]);
    } catch (e) {
      // setCustomer_data(payment_data);
      console.log(e);
    }
  };
  //fetch Customer Data
  // const getCustomer_Data = async () => {
  //   try {
  //     const data = await api.get("api/customer/list");
  //     //   console.log(data.data);
  //     setCustomer_data(data.data);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };
  //fetch Quotation By id
  const GetQuotation = async (data) => {
    if (data !== null && data !== undefined) {
      const id = {
        id: data,
      };
      setCustomer_id(data.CustomerId);
      try {
        const data = await api.post("api/master/referquotation", id);
        // console.log(data.data.data);
        setQuotation_fetch_data(data.data.data);
      } catch (e) {
        console.log(e);
      }

      //   console.log(customer_id);
    }
  };
  //fetch TagError By id
  const GetTagError = async () => {
    const id = {
      id: SaleorderData.SoId,
    };
    try {
      const data = await api.post("api/tagerror/list", id);
      // console.log(data.data);
      setTagErrorData(data.data);
    } catch (e) {
      console.log(e);
    }

    //   console.log(customer_id);
  };
  //fetch Data
  const getFactoryList = async () => {
    try {
      const data = await api.get("api/factory/list");

      setspFactory_fetch_data(data.data);
      // setData(data.data);
      // setDataFilter(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch freight_forwarder
  const GetFreightForwarder = async () => {
    try {
      const data = await api.get("api/forwarder/list");
      //   console.log(data.data);
      setFreight_forwarder_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  //fetch transhipment
  const GetTransshipment = async () => {
    try {
      const data = await api.get("api/transshipment/list");
      //   console.log(data.data);
      setTransshipment_fetch_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  //fetch commodity
  const GetCommodity = async () => {
    try {
      const data = await api.get("api/commodity/list");
      //   console.log(data.data);
      setCommodity_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  //fetch Liners
  const GetLiners = async () => {
    try {
      const data = await api.get("api/liners/list");
      //   console.log(data.data);
      setLiners_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Depots
  const GetDepots = async () => {
    try {
      const data = await api.get("api/depots/list");
      //   console.log(data.data);
      setDepots_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Terminal
  const GetTerminal = async () => {
    try {
      const data = await api.get("api/terminal/list");
      //   console.log(data.data);
      setTerminal_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Container
  const GetContaier = async () => {
    try {
      const data = await api.get("api/container/list");
      //   console.log(data.data);
      setContainer_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch FreightTerms
  const GetTerms = async () => {
    try {
      const data = await api.get("api/terms/list");
      //   console.log(data.data);
      setTerms_fetch_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch PolPod
  const GetPolPod = async () => {
    try {
      const data = await api.get("api/polpod/list");
      //   console.log(data.data);
      setPolPod_fetch_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Country
  const GetCountry = async () => {
    try {
      const data = await api.get("api/master/country");
      //   console.log(data.data);
      setCountry_fetch_data(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Group
  const FetchGroup = async () => {
    try {
      const data = await api.get("api/master/group");
      setGroupData(data.data.data);
      //   console.log(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Group
  const FetchStatusSo = async () => {
    try {
      const data = await api.get("api/master/saleorder/status");

      setStatusSo_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    maxDate();
    maxDate1();
    maxDate2();
  }, [MT_CNTR_AT_CY_STL_DATA, plan_data, laden_data]);

  useEffect(() => {
    if (value === "1") {
      GetLiners();
      printk();
      GetFreightForwarder();
      GetCommodity();
      GetDepots();
      GetTerminal();
      GetTransshipment();
      GetTerms();
      GetPolPod();
      GetCountry();
      GetContaier();
      getSaleOrder_Data();
      FetchGroup();
      getFactoryList();
      getPackage();
      FetchStatusSo();
      getLogStatus();
      GetIncoTerms();
    }
    if (value === "2") {
      getPayment_Data(SaleorderData.SoId);
    }
    if (value === "3") {
    }
    if (value === "4") {
    }
    if (value === "5") {
      GetTagError();
    }
    if (value === "6") {
      getMyFile();
    }
  }, [value]);

  const handleClose = () => {
    setMT_CNTR_AT_CY_STL(false);
    setSTUFFING_PLAN(false);
    setLADEN_CNTR(false);
  };

  const confirm_mt_stl = () => {
    if (voyage_no !== "" && mt_eta !== "" && pickUpDate !== "") {
      if (pickUpDate < date1st) {
        alert("เสียค่าใช้จ่ายเพิ่ม");
      }
      const data = {
        voyNo: voyage_no,
        mtEta: mt_eta,
        mtPick: pickUpDate,
        status: 1,
        ModId: EmpId,
      };
      setMT_CNTR_AT_CY_STL_DATA([...MT_CNTR_AT_CY_STL_DATA, data]);
      handleClose();
      setVoyage_no("");
      setMt_eta("");
      setPickupDate("");
    } else {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
    }
  };
  const maxDate = () => {
    const newDate = MT_CNTR_AT_CY_STL_DATA.map((x) => ({
      ...x,
      mtPick: new Date(x.mtPick),
    }));
    const _newDate = [...new Set(newDate.map((item) => item.mtPick))];

    const max = new Date(Math.max(..._newDate));

    setdatemt(moment(max).format("YYYY-MM-DD"));
  };

  const delete_mt_stel = (data) => {
    MT_CNTR_AT_CY_STL_DATA.splice(data, 1);
    setMT_CNTR_AT_CY_STL_DATA([...MT_CNTR_AT_CY_STL_DATA]);
  };

  const confirm_stuffing_plan = () => {
    if (spDate !== "" && spFactory !== "") {
      if (spDate > datemt) {
        alert("เสียค่าใช้จ่ายเพิ่ม");
      }
      const data = {
        spDate: spDate,
        spFactory: spFactory,
        containerId: "",
        qty: "",
        status: 1,
        ModId: EmpId,
      };
      setPlanData([...plan_data, data]);
      handleClose();
      setspDate("");
      setspFactory("");
      setspQty("");
      setcontainerId("");
      setspCancel("");
    } else {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
    }
  };
  const maxDate1 = () => {
    const newDate = plan_data.map((x) => ({
      ...x,
      spDate: new Date(x.spDate),
    }));
    const _newDate = [...new Set(newDate.map((item) => item.spDate))];

    const max = new Date(Math.max(..._newDate));

    setdateplan(moment(max).format("YYYY-MM-DD"));
  };
  const delete_stuffing_plan = (data) => {
    plan_data.splice(data, 1);
    setPlanData([...plan_data]);
  };

  const confirm_laden = () => {
    if (laden_voyNo !== "" && laden_etdDate !== "" && laden_Choose !== "") {
      if (laden_etdDate < plandate) {
        alert("เสียค่าใช้จ่ายเพิ่ม");
      }
      const data = {
        voyNo: laden_voyNo,
        etdDate: laden_etdDate,
        choose: laden_Choose,
        status: 1,
        ModId: EmpId,
      };
      setLadenData([...laden_data, data]);
      handleClose();
      setLaden_Choose("");
      setLaden_etdDate("");
      setLaden_voyNo("");
    } else {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
    }
  };
  const maxDate2 = () => {
    const newDate = laden_data.map((x) => ({
      ...x,
      etdDate: new Date(x.etdDate),
    }));
    const _newDate = [...new Set(newDate.map((item) => item.etdDate))];

    const max = new Date(Math.max(..._newDate));

    setladens(moment(max).format("YYYY-MM-DD"));
  };

  const delete_laden = (data) => {
    laden_data.splice(data, 1);
    setLadenData([...laden_data]);
  };
  //   console.log(plan_data);

  const [open, setDialogOpen] = useState(false);
  const [activeopen, setDialogActiveOpen] = useState(false);
  const [remarkStatus, setRemarkStatus] = useState("");

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  const handleDialogActiveOpen = () => {
    setDialogActiveOpen(true);
  };

  const handleDialogActiveClose = () => {
    setDialogActiveOpen(false);
  };

  /* table data */
  const [voy_dataFilter, setVoy_DataFilter] = useState([]);

  // const columns_voy = [
  //   { field: "voy", headerName: "VOYAGE NO", width: 150 },
  //   { field: "ETAIn", headerName: "ETA DATE", width: 150 },
  //   {
  //     field: "Weight",
  //     width: 130,
  //     sortable: false,
  //     renderCell: (params) => {
  //       const weight = params?.row?.weight.split("/");

  //       return (
  //         <>
  //           {Number(weight[0]) > Number(weight[1]) ? (
  //             <>
  //               <font color="red">
  //                 {weight[0]} / {weight[1]}{" "}
  //               </font>
  //             </>
  //           ) : (
  //             <>
  //               {weight[0]} / {weight[1]}
  //             </>
  //           )}
  //         </>
  //       );
  //     },
  //   },
  //   {
  //     field: "Teus",
  //     width: 130,
  //     sortable: false,
  //     renderCell: (params) => {
  //       const teus = params?.row?.teus.split("/");

  //       return (
  //         <>
  //           {Number(teus[0]) > Number(teus[1]) ? (
  //             <>
  //               <font color="red">
  //                 {teus[0]} / {teus[1]}{" "}
  //               </font>
  //             </>
  //           ) : (
  //             <>
  //               {teus[0]} / {teus[1]}
  //             </>
  //           )}
  //         </>
  //       );
  //     },
  //   },

  //   {
  //     field: "Action",
  //     width: 130,
  //     sortable: false,
  //     renderCell: (params) => {
  //       return (
  //         <>
  //           <Button
  //             variant="contained"
  //             size="small"
  //             style={{ backgroundColor: "#80c340" }}
  //             onClick={() => {
  //               setVoySelect(`${params.row.voy}`);
  //               setDialog_Voy(false);
  //             }}
  //           >
  //             Select
  //           </Button>
  //           <Tooltip
  //             href={"/Planner/EditShipSchedule/" + params.row.id}
  //             target="_blank"
  //             title="รายละเอียด"
  //           >
  //             <IconButton>
  //               <VisibilityOutlinedIcon style={{ margin: "10px" }} />
  //             </IconButton>
  //           </Tooltip>
  //         </>
  //       );
  //     },
  //   },
  // ];

  const columns_voy_In = [
    { field: "voy", headerName: "VOYAGE NO", width: 150 },
    { field: "ETAIn", headerName: "ETA DATE", width: 150 },
    {
      field: "Weight",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        const weight = params?.row?.weight.split("/");

        return (
          <>
            {Number(weight[0]) > Number(weight[1]) ? (
              <>
                <font color="red">
                  {weight[0]} / {weight[1]}{" "}
                </font>
              </>
            ) : (
              <>
                {weight[0]} / {weight[1]}
              </>
            )}
          </>
        );
      },
    },
    {
      field: "Teus",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        const teus = params?.row?.teus.split("/");

        return (
          <>
            {Number(teus[0]) > Number(teus[1]) ? (
              <>
                <font color="red">
                  {teus[0]} / {teus[1]}{" "}
                </font>
              </>
            ) : (
              <>
                {teus[0]} / {teus[1]}
              </>
            )}
          </>
        );
      },
    },
    {
      field: "Action",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Button
              variant="contained"
              size="small"
              style={{ backgroundColor: "#80c340" }}
              onClick={() => {
                setVoySelect(`${params.row.voy}`);
                // setDialog_Voy(false);
              }}
            >
              Select
            </Button>
            <Tooltip
              href={"/Planner/EditShipSchedule/" + params.row.id}
              target="_blank"
              title="รายละเอียด"
            >
              <IconButton>
                <VisibilityOutlinedIcon style={{ margin: "10px" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];
  const columns_voy_Out = [
    { field: "voy", headerName: "VOYAGE NO", width: 150 },
    { field: "ETAIn", headerName: "ETA DATE", width: 150 },
    {
      field: "Weight",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        const weight = params?.row?.weight.split("/");

        return (
          <>
            {Number(weight[0]) > Number(weight[1]) ? (
              <>
                <font color="red">
                  {weight[0]} / {weight[1]}{" "}
                </font>
              </>
            ) : (
              <>
                {weight[0]} / {weight[1]}
              </>
            )}
          </>
        );
      },
    },
    {
      field: "Teus",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        const teus = params?.row?.teus.split("/");

        return (
          <>
            {Number(teus[0]) > Number(teus[1]) ? (
              <>
                <font color="red">
                  {teus[0]} / {teus[1]}{" "}
                </font>
              </>
            ) : (
              <>
                {teus[0]} / {teus[1]}
              </>
            )}
          </>
        );
      },
    },
    {
      field: "Action",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Button
              variant="contained"
              size="small"
              style={{ backgroundColor: "#80c340" }}
              onClick={() => {
                setVoySelectOut(`${params.row.voy}`);
                setGetETAIn(params.row.ETAIn);
                // setDialog_Voy(false);
              }}
            >
              Select
            </Button>
            <Tooltip
              href={"/Planner/EditShipSchedule/" + params.row.id}
              target="_blank"
              title="รายละเอียด"
            >
              <IconButton>
                <VisibilityOutlinedIcon style={{ margin: "10px" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Sale Order
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">
                Customer Support / Sale Order
              </Typography>
              <Typography>
                <span>&nbsp;</span> / Detail
              </Typography>
            </Grid>
          </Grid>

          <div>
            <Grid item container justifyContent="flex-end">
              <Box justifyContent="flex-end">
                <FormControl style={{ width: "250px" }}>
                  <InputLabel id="demo-simple-select-label">สถานะ</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={statusSelect_data}
                    label="สถานะ"
                    onChange={(e) => {
                      setStatusSelect_data(e.target.value);
                    }}
                  >
                    <MenuItem value="" disabled>
                      <em>เลือก สถานะ SaleOrder</em>
                    </MenuItem>

                    {statusSO_data.map((option, index) => {
                      return (
                        <MenuItem key={index} value={`${option.TypeSaleOrderId}`}>
                          {option.TypeName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  onClick={changeStatus}
                  color="warning"
                  sx={{ m: "5px" }}
                >
                  อัพเดท
                </Button>
              </Box>
              <Typography className="textcolorgreen">
                #{SaleorderData.SoNumber}
              </Typography>
            </Grid>
          </div>

          <TabContext value={value}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                marginTop: "10px",
              }}
            >
              <TabList
                variant="scrollable"
                scrollButtons="auto"
                onChange={handleChangeTab}
                TabIndicatorProps={{
                  style: { backgroundColor: "transparent" },
                }}
                sx={{ overflow: "visible", "& .MuiTabs-scroller": { overflow: "visible !important" } }}
              >

                <Tab
                  sx={{
                    "&.Mui-selected": {
                      background: "#80C340",
                      color: "white",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    },
                    overflow: "visible", "& .MuiTabs-scroller": { overflow: "visible !important" }
                  }}
                  label={<Badge badgeContent={4} color="error" sx={{ "& .MuiBadge-badge": { top: '-10px' } }}><Typography>Infomation</Typography> </Badge>}
                  value="1"
                />


                {/* <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="Payment"
                value="2"
              /> */}
                <Tab
                  sx={{
                    "&.Mui-selected": {
                      background: "#80C340",
                      color: "white",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    },
                  }}
                  label="Work Order"
                  value="3"
                />
                <Tab
                  sx={{
                    "&.Mui-selected": {
                      background: "#80C340",
                      color: "white",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    },
                  }}
                  label="Container List"
                  value="4"
                />
                <Tab
                  sx={{
                    "&.Mui-selected": {
                      background: "#80C340",
                      color: "white",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    },
                  }}
                  label="Tag Error"
                  value="5"
                />
                <Tab
                  sx={{
                    "&.Mui-selected": {
                      background: "#80C340",
                      color: "white",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    },
                  }}
                  label="Attach file"
                  value="6"
                />
                <Tab
                  sx={{
                    "&.Mui-selected": {
                      background: "#80C340",
                      color: "white",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    },
                  }}
                  label="log status"
                  value="7"
                />
              </TabList>
            </Box>
            <TabPanel value="1">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {SaleorderData.StatusCancel == "0" ? (
                    <Alert severity="error">
                      ใบสั่งขาย ถูกยกเลิก เหตุผล : {SaleorderData.RemarkStatus}
                    </Alert>
                  ) : null}
                  {SaleorderData.StatusCancel == "1" &&
                    SaleorderData.RemarkStatus != "" ? (
                    <Alert severity="success">
                      ใบสั่งขาย ได้กลับมาใช้อีกครั้ง เหตุผล :{" "}
                      {SaleorderData.RemarkStatus}
                    </Alert>
                  ) : null}

                  <Formik
                    enableReinitialize
                    initialValues={{
                      Forwarding: SaleorderData?.ForwardingName
                        ? SaleorderData?.ForwardingName
                        : "",
                      customer_name: SaleorderData?.CustomerName
                        ? SaleorderData?.CustomerName
                        : "",
                      quotation_no: SaleorderData?.QuotationId
                        ? SaleorderData?.QuotationId
                        : "",
                      shipper_ref_no: SaleorderData?.ShipperRefNo
                        ? SaleorderData?.ShipperRefNo
                        : "",
                      shipper_si_no: SaleorderData?.ShippedSiNo
                        ? SaleorderData?.ShippedSiNo
                        : "",
                      shipper_invoice_no: SaleorderData?.ShipperInvoiceNo
                        ? SaleorderData?.ShipperInvoiceNo
                        : "",
                      detail_quotation: SaleorderData?.ServiceInfo,
                      volume_container: SaleorderData?.soContainerTypeId
                        ? SaleorderData?.soContainerTypeId
                        : "",
                      volume_quantity: SaleorderData?.Qty
                        ? SaleorderData?.Qty
                        : "",
                      volume_cancel: "",
                      etd_pol: SaleorderData.EtdPol ? SaleorderData.EtdPol : "",
                      closing_date: SaleorderData?.EtdCloseingDate
                        ? SaleorderData?.EtdCloseingDate
                        : "",
                      closing_time: SaleorderData?.EtdCloseingTime
                        ? SaleorderData?.EtdCloseingTime
                        : "",
                      booking_no: SaleorderData?.ShippingBookingNo
                        ? SaleorderData?.ShippingBookingNo
                        : "",
                      liners: SaleorderData?.ShippingLinersId
                        ? SaleorderData?.ShippingLinersId
                        : "",
                      freight_forwarder:
                        SaleorderData?.ShippingFreightForwarderId
                          ? SaleorderData?.ShippingFreightForwarderId
                          : "",
                      container_require: SaleorderData.ShippingContainerReqCheck
                        ?.data
                        ? SaleorderData.ShippingContainerReqCheck?.data
                        : 0,
                      container_require_select:
                        SaleorderData?.ShippingContainerRequired
                          ? SaleorderData?.ShippingContainerRequired
                          : "",
                      grade: SaleorderData?.ShippingGrade
                        ? SaleorderData?.ShippingGrade
                        : "",
                      apply_layer_plastic_sheet: SaleorderData.ShippingApply
                        ?.data[0]
                        ? SaleorderData.ShippingApply?.data[0]
                        : "",
                      commodity: SaleorderData?.ShippingCommodityId
                        ? SaleorderData?.ShippingCommodityId
                        : "",
                      packaging: SaleorderData?.ShippingPackaging
                        ? SaleorderData?.ShippingPackaging
                        : "",
                      det: SaleorderData?.FreePoLDet
                        ? SaleorderData?.FreePoLDet
                        : "",
                      dem: SaleorderData.FreePoLDem
                        ? SaleorderData.FreePoLDem
                        : "",
                      com: SaleorderData.FreePoLCom
                        ? SaleorderData.FreePoLCom
                        : "",
                      c_det: SaleorderData.ComDet,
                      c_dem: SaleorderData.ComDem,
                      choose: SaleorderData?.PickupChoose
                        ? SaleorderData?.PickupChoose
                        : "",
                      empty_laden: SaleorderData?.PickupEmpty
                        ? SaleorderData?.PickupEmpty
                        : "",
                      first_pickup: SaleorderData.PickupFirst
                        ? SaleorderData.PickupFirst
                        : "",
                      actual_pickup: SaleorderData.ActualPickupDate
                        ? SaleorderData.ActualPickupDate
                        : "",

                      depots: SaleorderData?.PickupDepotsId
                        ? SaleorderData?.PickupDepotsId
                        : "",
                      voyage_no: SaleorderData?.PickupVoyageNo
                        ? SaleorderData?.PickupVoyageNo
                        : "",
                      mt_etd_pol: SaleorderData?.PickupMt
                        ? SaleorderData?.PickupMt
                        : "",
                      return_date: SaleorderData?.ReturnDate
                        ? SaleorderData?.ReturnDate
                        : "",
                      actual_return_date: SaleorderData?.ActualReturnDate
                        ? SaleorderData?.ActualReturnDate
                        : "",
                      terminals: SaleorderData?.TerminalId
                        ? SaleorderData?.TerminalId
                        : "",
                      conuntry: SaleorderData?.CountryId
                        ? SaleorderData?.CountryId
                        : "",
                      port_of_discharge: SaleorderData?.PortofDischarge
                        ? SaleorderData?.PortofDischarge
                        : "",
                      pod_terminal: SaleorderData?.PodTerminal
                        ? SaleorderData?.PodTerminal
                        : "",
                      first_vissel: SaleorderData?.FirstVessel
                        ? SaleorderData?.FirstVessel
                        : "",
                      first_vissel_transshipment:
                        SaleorderData?.FirstTranshipment
                          ? SaleorderData?.FirstTranshipment
                          : "",
                      second_vissel: SaleorderData?.SecondVessel
                        ? SaleorderData?.SecondVessel
                        : "",
                      second_vissel_transshipment:
                        SaleorderData?.SecondTranshipment
                          ? SaleorderData?.SecondTranshipment
                          : "",
                      third_vissel: SaleorderData?.ThirdVessel
                        ? SaleorderData?.ThirdVessel
                        : "",
                      third_vissel_transshipment:
                        SaleorderData?.ThirdTranshipment
                          ? SaleorderData?.ThirdTranshipment
                          : "",
                      eta_pod: moment(SaleorderData?.EtaPod).format(
                        "YYYY-MM-DD"
                      )
                        ? moment(SaleorderData?.EtaPod).format("YYYY-MM-DD")
                        : "",
                      freight_terms: SaleorderData.FreightTerms
                        ? SaleorderData.FreightTerms
                        : "",
                      inco_terms: SaleorderData?.IncoTerms
                        ? SaleorderData?.IncoTerms
                        : "",
                      consig_time: SaleorderData?.ConsigTime
                        ? SaleorderData?.ConsigTime
                        : "",
                      conuntrylinerId: SaleorderData?.CountryIdLiner
                        ? SaleorderData?.CountryIdLiner
                        : "",
                      cut_off_si: SaleorderData?.CutOffSl
                        ? SaleorderData?.CutOffSl
                        : "",
                      cut_off_vgm: SaleorderData?.CutOffVgm
                        ? SaleorderData?.CutOffVgm
                        : "",
                      fumigation: SaleorderData?.Fumigation
                        ? SaleorderData?.Fumigation
                        : "",
                      phyto_cert: SaleorderData?.PhytoCert
                        ? SaleorderData?.PhytoCert
                        : "",
                      doc_mt: SaleorderData.DocMt?.data[0],
                      doc_cntr: SaleorderData.DocCntr?.data[0],
                      doc_inv: SaleorderData.DocInv?.data[0],
                      doc_export: SaleorderData.DocExport?.data[0],
                      doc_si: SaleorderData.DocSi?.data[0],
                      doc_vmg: SaleorderData.DocVmg?.data[0],
                      doc_carco: SaleorderData.DocCarco?.data[0],
                      fumigation_remark: SaleorderData?.FumigationRemark
                        ? SaleorderData?.FumigationRemark
                        : "",
                      phyto_cert_remark: SaleorderData?.PhytoCertRemark
                        ? SaleorderData?.PhytoCertRemark
                        : "",
                      choice_com_calculate: "",
                      RemarkLog:""
                    }}
                    validate={(values) => {
                      const errors = {};
                      // if (!values.Forwarding || values.Forwarding === "") {
                      //   errors.Forwarding = "Required";
                      // }
                      // if (!values.customer_name || values.customer_name === "") {
                      //   errors.customer_name = "Required";
                      // }

                      return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                      setTimeout(() => {
                        // console.log(customer_id);
                        const MySwal = withReactContent(Swal);

                        const data = {
                          id: id,
                          forwardId: SaleorderData.ForwardingId,
                          cusId: SaleorderData.CustomerId,
                          quotationId: SaleorderData.QuotationId,
                          shipperInvoiceNo: values.shipper_invoice_no,
                          shipperRefNo: values.shipper_ref_no,
                          shipperSiNo: values.shipper_si_no,
                          containerId: values.volume_container,
                          qty: values.volume_quantity,
                          etdPol: values.etd_pol,
                          etdCloseingDate: values.closing_date,
                          etdCloseingDate: values.closing_date,
                          etdCloseingTime: values.closing_time,
                          shippingBookingNo: values.booking_no,
                          shippingLinerId: values.liners,
                          shippingFreightForId: values.freight_forwarder,
                          shippingContainerReqCheck: values.container_require,
                          shippingContainerRequired:
                            values.container_require_select,
                          shippingCommodityId: values.commodity,
                          shippingPackaging: values.packaging,
                          shippingGrade: values.grade,
                          shippingApply: values.apply_layer_plastic_sheet,
                          freePolDet: values.det,
                          freePolDem: values.dem,
                          freePolCom: values.com,
                          ComDet: values.c_det,
                          ComDem: values.c_dem,
                          pickupChoose: values.choose,
                          pickupEmpty: values.empty_laden,
                          pickupFirst: values.first_pickup,
                          ActualPickupDate: values.actual_pickup,
                          pickupDepotsId: values.depots,
                          pickupVoyageNo: voy_no_select,
                          pickupMt: values.mt_etd_pol,
                          returnDate: values.return_date,
                          ActualReturnDate: values.actual_return_date,
                          terminalId: values.terminals,
                          countryId: values.conuntry,
                          portofDischarge: values.port_of_discharge,
                          podTerminal: values.pod_terminal,
                          firstVessel: values.first_vissel,
                          firstTranshipment: values.first_vissel_transshipment,
                          secondVessel: values.second_vissel,
                          secondTranshipment:
                            values.second_vissel_transshipment,
                          thirdVessel: values.third_vissel,
                          thirdTranshipment: values.third_vissel_transshipment,
                          etaPod: values.eta_pod,
                          freightTerms: values.freight_terms,
                          incoTerms: values.inco_terms,
                          consigTime: values.consig_time,
                          cutOffSl: values.cut_off_si,
                          cutOffVgm: values.cut_off_vgm,
                          fumigation: values.fumigation,
                          phytoCert: values.phyto_cert,
                          docMt: values.doc_mt,
                          docCntr: values.doc_cntr,
                          docInv: values.doc_inv,
                          docExport: values.doc_export,
                          docSi: values.doc_si,
                          docVmg: values.doc_vmg,
                          docCarco: values.doc_carco,
                          mt: MT_CNTR_AT_CY_STL_DATA,
                          plan: plan_data,
                          laden: laden_data,
                          fumiRemark: values.fumigation_remark,
                          phyRemark: values.phyto_cert_remark,
                          status: statusSelect_data,
                          ModId: EmpId,
                          countryIdLiner: values.conuntrylinerId,
                          RemarkLog:remarklog
                        };

                        api
                          .post("api/saleorder/update", data)
                          .then((respose) => {
                            const MySwal = withReactContent(Swal);

                            MySwal.fire({
                              icon: "success",
                              didOpen: () => {
                                MySwal.clickConfirm();
                              },
                            }).then(() => {
                              return MySwal.fire(
                                "สำเร็จ!",
                                "แก้ไข Sale Order สำเร็จ !",
                                "success"
                              ).then((result) => {
                                if (result.isConfirmed) {
                                  // history.push("/CustomerSupport/SaleOrder");
                                  getSaleOrder_Data();
                                }
                              });
                            });
                          })
                          .catch((err) => {
                            console.log(err);
                          });

                        //   alert(JSON.stringify(values, null, 2));
                        setSubmitting(false);
                      }, 400);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      setFieldValue,
                      /* and other goodies */
                    }) => (
                      <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
                        <h6
                          style={{ marginTop: "10px" }}
                          className="textcolordarkblue"
                        >
                          Forwarding
                        </h6>
                        <Grid container>
                          <Grid item xs={12} md={12}>
                            <div>
                              <TextField
                                name="Forwarding"
                                label="Forwarding "
                                variant="outlined"
                                placeholder="Forwarding "
                                onChange={handleChange}
                                onBlur={handleBlur}
                                InputLabelProps={{ shrink: true }}
                                defaultValue={values.Forwarding}
                                value={values.Forwarding}
                                disabled
                                //   {...params}
                                fullWidth
                              />
                            </div>
                            <h6
                              style={{ marginTop: "10px" }}
                              className="textcolordarkblue"
                            >
                              CUSTOMER
                            </h6>
                            <div>
                              {/* <Autocomplete
                      disablePortal
                      options={customer_data}
                      getOptionLabel={(option) => option.CustomerName}
                      onChange={(x, y) => GetQuotation(x, y)}
                      renderInput={(params) => ( */}
                              <TextField
                                name="customer_name"
                                label="CUSTOMER NAME"
                                variant="outlined"
                                placeholder="Customer Name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                InputLabelProps={{ shrink: true }}
                                defaultValue={values.customer_name}
                                value={values.customer_name}
                                disabled
                                //   {...params}
                                fullWidth
                              />
                              {/* )}
                    /> */}
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <FormControl sx={{ width: "50%" }}>
                                <InputLabel>Refer Quotation no.</InputLabel>

                                <Select
                                  name="quotation_no"
                                  value={
                                    values.quotation_no
                                      ? values.quotation_no
                                      : ""
                                  }
                                  onChange={(e) => {
                                    setFieldValue(
                                      "quotation_no",
                                      e.target.value
                                    );
                                    setQuotation_id(e.target.value);
                                    const _quotationId = e.target.value;
                                    const quatation = quotation_fetch_data.find(
                                      (x) => x.QuotationId === _quotationId
                                    );

                                    setFieldValue(
                                      "detail_quotation",
                                      quatation.ServiceInfo
                                    );

                                    //   console.log(quatation);
                                  }}
                                  onBlur={handleBlur}
                                  label="Refer Quotation no."
                                >
                                  <MenuItem value="" disabled>
                                    <em>กรุณาค้นหา CustomerName </em>
                                  </MenuItem>
                                  {quotation_fetch_data.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.QuotationId}
                                      >
                                        {option.QuotationNo}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              <TextField
                                name="shipper_ref_no"
                                label="SHIPPER REF NO."
                                variant="outlined"
                                placeholder="SHIPPER REF NO."
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginLeft: 5 }}
                                InputLabelProps={{ shrink: true }}
                                value={values.shipper_ref_no}
                              />
                              {errors.shipper_ref_no &&
                                touched.shipper_ref_no &&
                                errors.shipper_ref_no}
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <TextField
                                name="shipper_si_no"
                                label="SHIPPER SI NO."
                                variant="outlined"
                                placeholder="SHIPPER SI NO."
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                value={values.shipper_si_no}
                              />
                              {errors.shipper_si_no &&
                                touched.shipper_si_no &&
                                errors.shipper_si_no}
                              <TextField
                                name="shipper_invoice_no"
                                label="SHIPPER INVOICE. NO."
                                variant="outlined"
                                placeholder="SHIPPER INVOICE. NO."
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                value={values.shipper_invoice_no}
                              />
                              {errors.shipper_invoice_no &&
                                touched.shipper_invoice_no &&
                                errors.shipper_invoice_no}
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <TextField
                                label="รายละเอียดตู้ Quotation"
                                value={values.detail_quotation}
                                name="detail_quotation"
                                InputLabelProps={{ shrink: true }}
                                disabled
                                multiline
                                rows={2}
                                fullWidth
                              />

                              {/* <Button
                      type="button"
                      variant="outlined"
                      size="small"
                      style={{
                        color: "#007BFF",
                        borderColor: "#007BFF",

                        marginRight: "10px",
                        marginLeft: "10px",
                        textTransform: "none",
                      }}
                    >
                      แก้ไข
                    </Button> */}

                              {/* <Button
                              type="button"
                              variant="contained"
                              style={{
                                background: "#007BFF",
                                borderColor: "#007BFF",
                                marginRight: "10px",
                                marginLeft: "10px",
                                textTransform: "none",
                              }}
                            >
                              {isSubmitting && <CircularProgress size={22} />}
                              {!isSubmitting && "ยืนยัน"}
                            </Button> */}
                            </div>
                            <h6
                              style={{ marginTop: "10px" }}
                              className="textcolordarkblue"
                            >
                              VOLUME
                            </h6>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <FormControl sx={{ width: "25%" }}>
                                <InputLabel>Container</InputLabel>
                                <Select
                                  name="volume_container"
                                  label="Container"
                                  value={values.volume_container}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก Container</em>
                                  </MenuItem>
                                  {container_data.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.ContainerTypeId}
                                      >
                                        {option.ContainerTypeName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              <TextField
                                name="volume_quantity"
                                label="Quantity"
                                variant="outlined"
                                placeholder="Quantity"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{
                                  width: "25%",
                                  marginRight: 5,
                                  marginLeft: 5,
                                }}
                                InputLabelProps={{ shrink: true }}
                                value={values.volume_quantity}
                              />
                              {errors.volume_quantity &&
                                touched.volume_quantity &&
                                errors.volume_quantity}
                              {SaleorderData.StatusCancel == "1" ? (
                                <Button
                                  variant="outlined"
                                  style={{
                                    width: "25%",
                                    marginRight: 5,
                                    borderColor: "red",
                                  }}
                                  onClick={handleDialogOpen}
                                >
                                  CANCEL
                                </Button>
                              ) : (
                                <Button
                                  variant="outlined"
                                  style={{
                                    width: "25%",
                                    marginRight: 5,
                                    borderColor: "green",
                                  }}
                                  onClick={handleDialogActiveOpen}
                                >
                                  Active
                                </Button>
                              )}
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <FormControl sx={{ width: "50%", mr: "5px" }}>
                                <InputLabel>COMMODITY</InputLabel>
                                <Select
                                  name="commodity"
                                  label="COMMODITY"
                                  value={values.commodity}
                                  InputLabelProps={{ shrink: true }}
                                  onBlur={handleBlur}
                                  onChange={(e) => {
                                    setFieldValue("commodity", e.target.value);
                                    setQuotation_id(e.target.value);
                                    const _quotationId = e.target.value;
                                    const quatation = quotation_fetch_data.find(
                                      (x) => x.CommodityId === _quotationId
                                    );
                                  }}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก COMMODITY </em>
                                  </MenuItem>
                                  {quotation_fetch_data.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.CommodityId}
                                      >
                                        {option.CommodityName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              <FormControl sx={{ width: "25%", mr: "5px" }}>
                                <InputLabel>PACKAGING</InputLabel>
                                <Select
                                  name="packaging"
                                  label="PACKAGING"
                                  value={values.packaging}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก PACKAGING </em>
                                  </MenuItem>

                                  {package_data.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.PackageId}
                                      >
                                        {option.PackageName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                            <h6
                              style={{ marginTop: "10px" }}
                              className="textcolordarkblue"
                            >
                              ETD POL
                            </h6>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <TextField
                                name="etd_pol"
                                label="ETD POL"
                                type="date"
                                value={values.etd_pol}
                                defaultValue={values.etd_pol}
                                InputProps={{ inputProps: { min: Date.now() } }}
                                onChange={(e) => {
                                  setFieldValue("etd_pol", e.target.value);

                                  const nformat = moment(
                                    new Date(e.target.value),
                                    "DD/MM/YYYY"
                                  ).format("YYYY/MM/DD");

                                  setEtd(nformat);
                                  if (values.dem != "" && values.det != "") {
                                    let cal_days =
                                      -(
                                        parseInt(values.det) +
                                        parseInt(values.dem)
                                      ) + 2;
                                    let cal_dayss = parseInt(values.dem);
                                    let date_now = +new Date(e.target.value);
                                    if (values.det != "" && values.dem != "") {
                                      setFieldValue(
                                        "first_pickup",
                                        moment(
                                          new Date(
                                            date_now +
                                            cal_days * 24 * 60 * 60 * 1000
                                          )
                                        ).format("YYYY-MM-DD")
                                      );
                                      setdate1st(
                                        moment(
                                          new Date(
                                            date_now +
                                            (cal_days + cal_dayss) *
                                            24 *
                                            60 *
                                            60 *
                                            1000
                                          )
                                        ).format("YYYY-MM-DD")
                                      );
                                    }
                                  }
                                }}
                                sx={{ width: "25%" }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                              <TextField
                                name="closing_date"
                                label="CLOSING DATE"
                                type="date"
                                value={values.closing_date}
                                defaultValue={values.closing_date}
                                InputProps={{
                                  inputProps: { max: values.etd_pol },
                                }}
                                onChange={(e) => {
                                  setFieldValue("closing_date", e.target.value);
                                  const mformat = moment(
                                    new Date(e.target.value),
                                    "DD/MM/YYYY"
                                  ).format("YYYY/MM/DD");
                                  setClosingdate(mformat);
                                  if (
                                    values.com != "" &&
                                    values.det == "" &&
                                    values.dem == "" &&
                                    values.choice_com_calculate == "2"
                                  ) {
                                    let date_now = +new Date(e.target.value);

                                    setFieldValue(
                                      "first_pickup",
                                      moment(
                                        new Date(
                                          date_now +
                                          values.com * 24 * 60 * 60 * 1000
                                        )
                                      ).format("YYYY-MM-DD")
                                    );
                                  }
                                }}
                                style={{
                                  width: "25%",
                                  marginRight: 5,
                                  marginLeft: 5,
                                  border:
                                  values.closing_date >= values.etd_pol &&
                                    "#EE4B2B 2px solid",
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                              <TextField
                                name="closing_time"
                                label="CLOSING TIME"
                                variant="outlined"
                                placeholder="CLOSING TIME"
                                type="time"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                value={values.closing_time}
                              />
                              {errors.closing_time &&
                                touched.closing_time &&
                                errors.closing_time}
                              <FormControl sx={{ width: "25%", mr: "5px" }}>
                                <InputLabel>Country</InputLabel>
                                <Select
                                  name="conuntrylinerId"
                                  label="Country"
                                  value={values.conuntrylinerId}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก Country </em>
                                  </MenuItem>
                                  {country_fetch_data.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.CountryId}
                                      >
                                        {option.CountryName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                            <h6
                              style={{ marginTop: "10px" }}
                              className="textcolordarkblue"
                            >
                              SHIPPING LINE
                            </h6>
                            <div style={{ marginTop: 10 }}>
                              <TextField
                                name="booking_no"
                                label="BOOKING NO."
                                variant="outlined"
                                placeholder="BOOKING NO."
                                onChange={handleChange}
                                onBlur={handleBlur}
                                InputLabelProps={{ shrink: true }}
                                value={values.booking_no}
                                fullWidth
                              />
                              {errors.booking_no &&
                                touched.booking_no &&
                                errors.booking_no}
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <FormControl sx={{ width: "50%" }}>
                                <InputLabel>LINERS</InputLabel>
                                <Select
                                  name="liners"
                                  label="LINERS"
                                  value={values.liners}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  disabled={values.freight_forwarder !== ""}
                                >
                                  <MenuItem value="">
                                    <em>เลือก Liners </em>
                                  </MenuItem>
                                  {liners_data.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.LinersId}
                                      >
                                        {option.LinersName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              <FormControl sx={{ width: "50%", ml: "5px" }}>
                                <InputLabel>FREIGHT FORWARDER</InputLabel>
                                <Select
                                  name="freight_forwarder"
                                  label="FREIGHT FORWARDER"
                                  value={values.freight_forwarder}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  disabled={values.liners !== ""}
                                >
                                  <MenuItem value="">
                                    <em>เลือก FREIGHT FORWARDER </em>
                                  </MenuItem>
                                  {freight_forwarder_data.map(
                                    (option, index) => {
                                      return (
                                        <MenuItem
                                          key={index}
                                          value={option.FreightId}
                                        >
                                          {option.FreightForwarderName}
                                        </MenuItem>
                                      );
                                    }
                                  )}
                                </Select>
                              </FormControl>
                            </div>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      values.container_require == 1
                                        ? true
                                        : false
                                    }
                                    onClick={(e) => {
                                      setFieldValue(
                                        "container_require",
                                        e.target.checked ? 1 : 0
                                      );
                                      setFieldValue("depots", "");
                                      // console.log(values);
                                    }}
                                  />
                                }
                                label="Container Stock"
                              />
                            </FormGroup>
                            {values.container_require == 1 ? (
                              <div>
                                <div style={{ display: "flex", marginTop: 10 }}>
                                  <FormControl sx={{ width: "50%", mr: "5px" }}>
                                    <InputLabel>Container Stock</InputLabel>
                                    <Select
                                      name="container_require_select"
                                      label="Container Stock"
                                      value={values.container_require_select}
                                      InputLabelProps={{ shrink: true }}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    >
                                      <MenuItem value="Stock">Stock</MenuItem>
                                    </Select>
                                  </FormControl>
                                  <TextField
                                    name="grade"
                                    label="Grade"
                                    variant="outlined"
                                    placeholder="Grade"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    style={{ width: "25%", marginRight: 5 }}
                                    InputLabelProps={{ shrink: true }}
                                    value={values.grade}
                                  />
                                  {errors.grade &&
                                    touched.grade &&
                                    errors.grade}
                                  <FormControl sx={{ width: "50%", ml: "5px" }}>
                                    <InputLabel>
                                      APPLY LAYER PLASTIC SHeET
                                    </InputLabel>
                                    <Select
                                      name="apply_layer_plastic_sheet"
                                      label="APPLY LAYER PLASTIC SHeET"
                                      value={values.apply_layer_plastic_sheet}
                                      InputLabelProps={{ shrink: true }}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={0}>No</MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>
                              </div>
                            ) : null}
                            <h6
                              style={{ marginTop: "10px" }}
                              className="textcolordarkblue"
                            >
                              FREE TIME AT POL
                            </h6>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <TextField
                                name="det"
                                label="Detention"
                                type="number"
                                variant="outlined"
                                placeholder="DET"
                                onChange={(e) => {
                                  setFieldValue("det", e.target.value);
                                  let cal_days =
                                    -(
                                      parseInt(e.target.value) +
                                      parseInt(values.dem)
                                    ) + 2;
                                  let date_now = +new Date(values.etd_pol);
                                  let cal_det = +parseInt(e.target.value);
                                  let cal_dayss = parseInt(values.dem);
                                  if (
                                    e.target.value != "" &&
                                    values.dem != "" &&
                                    values.etd_pol != ""
                                  ) {
                                    setFieldValue(
                                      "first_pickup",
                                      moment(
                                        new Date(
                                          date_now +
                                          cal_days * 24 * 60 * 60 * 1000
                                        )
                                      ).format("YYYY-MM-DD")
                                    );
                                    setFieldValue(
                                      "return_date",
                                      moment(
                                        new Date(
                                          date_now +
                                          cal_days * 24 * 60 * 60 * 1000 +
                                          (cal_det - 1) * 24 * 60 * 60 * 1000
                                        )
                                      ).format("YYYY-MM-DD")
                                    );

                                    setdate1st(
                                      moment(
                                        new Date(
                                          date_now +
                                          (cal_days + cal_dayss) *
                                          24 *
                                          60 *
                                          60 *
                                          1000
                                        )
                                      ).format("YYYY-MM-DD")
                                    );
                                  }
                                  if (e.target.value == "") {
                                    setFieldValue("first_pickup", "");
                                  }
                                  e.target.value.length >= 1 || values.dem != ""
                                    ? setComDisable(true)
                                    : setComDisable(false);
                                }}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                disabled={DetDemDisable}
                                value={values.det}
                              />
                              {errors.det && touched.det && errors.det}
                              <TextField
                                name="dem"
                                label="Demurrage"
                                type="number"
                                variant="outlined"
                                placeholder="DEM"
                                onChange={(e) => {
                                  setFieldValue("dem", e.target.value);
                                  let cal_days =
                                    -(
                                      parseInt(values.det) +
                                      parseInt(e.target.value)
                                    ) + 2;
                                  let cal_dayss = parseInt(values.dem);
                                  let cal_det = +parseInt(values.det);
                                  let date_now = +new Date(values.etd_pol);
                                  if (
                                    values.det != "" &&
                                    e.target.value != "" &&
                                    values.etd_pol != ""
                                  ) {
                                    setFieldValue(
                                      "first_pickup",
                                      moment(
                                        new Date(
                                          date_now +
                                          cal_days * 24 * 60 * 60 * 1000
                                        )
                                      ).format("YYYY-MM-DD")
                                    );
                                    setFieldValue(
                                      "return_date",
                                      moment(
                                        new Date(
                                          date_now +
                                          cal_days * 24 * 60 * 60 * 1000 +
                                          (cal_det - 1) * 24 * 60 * 60 * 1000
                                        )
                                      ).format("YYYY-MM-DD")
                                    );
                                    setdate1st(
                                      moment(
                                        new Date(
                                          date_now +
                                          (cal_days + cal_dayss) *
                                          24 *
                                          60 *
                                          60 *
                                          1000
                                        )
                                      ).format("YYYY-MM-DD")
                                    );
                                  }
                                  if (e.target.value == "") {
                                    setFieldValue("first_pickup", "");
                                  }
                                  e.target.value.length >= 1 || values.det != ""
                                    ? setComDisable(true)
                                    : setComDisable(false);
                                }}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                disabled={DetDemDisable}
                                value={values.dem}
                              />
                              {errors.dem && touched.dem && errors.dem}

                              <TextField
                                name="com"
                                label="Combined"
                                type="number"
                                variant="outlined"
                                placeholder="COM"
                                onChange={(e) => {
                                  setFieldValue("com", e.target.value);
                                  setCom_caluateSelect(true);
                                  if (e.target.value == "") {
                                    setCom_caluateSelect(false);
                                    setFieldValue("first_pickup", "");
                                    setFieldValue("choice_com_calculate", "");
                                  }
                                  e.target.value.length >= 1
                                    ? setDetDemDisable(true)
                                    : setDetDemDisable(false);
                                }}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                value={values.com}
                                disabled={ComDisable}
                              />
                              {errors.com && touched.com && errors.com}
                              {com_caluateSelect ? (
                                <>
                                  <TextField
                                    name="c_det"
                                    label="DET"
                                    type="number"
                                    error={
                                      parseInt(values.c_det) +
                                        parseInt(values.c_dem) <=
                                        values.com
                                        ? false
                                        : true
                                    }
                                    variant="outlined"
                                    placeholder="DET"
                                    onChange={(e) => {
                                      setFieldValue("c_det", e.target.value);

                                      // setDetValue(e.target.value);
                                      let cal_days =
                                        -(
                                          parseInt(e.target.value) +
                                          parseInt(values.c_dem)
                                        ) + 2;
                                      let cal_dayss = +parseInt(values.c_dem);
                                      let cal_det = +parseInt(e.target.value);

                                      let date_now = +new Date(values.etd_pol);
                                      if (
                                        e.target.value != "" &&
                                        values.c_dem != "" &&
                                        values.etd_pol != ""
                                      ) {
                                        setFieldValue(
                                          "first_pickup",
                                          moment(
                                            new Date(
                                              date_now +
                                              cal_days * 24 * 60 * 60 * 1000
                                            )
                                          ).format("YYYY-MM-DD")
                                        );

                                        setFieldValue(
                                          "return_date",
                                          moment(
                                            new Date(
                                              date_now +
                                              cal_days * 24 * 60 * 60 * 1000 +
                                              (cal_det - 1) *
                                              24 *
                                              60 *
                                              60 *
                                              1000
                                            )
                                          ).format("YYYY-MM-DD")
                                        );
                                      }
                                      if (e.target.value == "") {
                                        setFieldValue("first_pickup", "");
                                      }
                                    }}
                                    onBlur={handleBlur}
                                    style={{ width: "50%", marginRight: 5 }}
                                    InputLabelProps={{ shrink: true }}
                                    value={values.c_det}
                                  />
                                  <TextField
                                    name="c_dem"
                                    label="DEM"
                                    error={
                                      parseInt(values.c_det) +
                                        parseInt(values.c_dem) <=
                                        values.com
                                        ? false
                                        : true
                                    }
                                    type="number"
                                    variant="outlined"
                                    placeholder="DEM"
                                    onChange={(e) => {
                                      setFieldValue("c_dem", e.target.value);
                                      let cal_days =
                                        -(
                                          parseInt(values.c_det) +
                                          parseInt(e.target.value)
                                        ) + 2;
                                      let cal_dayss = +parseInt(values.c_dem);
                                      let cal_det = +parseInt(values.c_det);
                                      let date_now = +new Date(values.etd_pol);
                                      if (
                                        values.c_det != "" &&
                                        e.target.value != "" &&
                                        values.etd_pol != "" &&
                                        parseInt(values.c_det) +
                                        parseInt(e.target.value) <=
                                        values.com
                                      ) {
                                        setFieldValue(
                                          "first_pickup",
                                          moment(
                                            new Date(
                                              date_now +
                                              cal_days * 24 * 60 * 60 * 1000
                                            )
                                          ).format("YYYY-MM-DD")
                                        );
                                        setFieldValue(
                                          "return_date",
                                          moment(
                                            new Date(
                                              date_now +
                                              cal_days * 24 * 60 * 60 * 1000 +
                                              (cal_det - 1) *
                                              24 *
                                              60 *
                                              60 *
                                              1000
                                            )
                                          ).format("YYYY-MM-DD")
                                        );
                                      }
                                      if (e.target.value == "") {
                                        setFieldValue("first_pickup", "");
                                      }
                                    }}
                                    onBlur={handleBlur}
                                    style={{ width: "50%", marginRight: 5 }}
                                    InputLabelProps={{ shrink: true }}
                                    value={values.c_dem}
                                  />
                                  {/* <FormControl sx={{ width: "50%", mr: "5px" }}>
                                  <InputLabel>คำนวณโดย</InputLabel>
                                  <Select
                                    name="choice_com_calculate"
                                    value={values.choice_com_calculate}
                                    label="คำนวณโดย"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "choice_com_calculate",
                                        e.target.value
                                      );

                                      let date_now = +new Date(values.eta_pod);
                                      if (
                                        e.target.value == "1" &&
                                        values.eta_pod != "" &&
                                        values.com != ""
                                      ) {
                                        let com_value = -values.com + 1;
                                        setFieldValue(
                                          "first_pickup",
                                          moment(
                                            new Date(
                                              date_now +
                                              com_value * 24 * 60 * 60 * 1000
                                            )
                                          ).format("YYYY-MM-DD")
                                        );
                                      }
                                      let date_closing = +new Date(
                                        values.closing_date
                                      );
                                      if (
                                        e.target.value == "2" &&
                                        values.closing_date != "" &&
                                        values.com != ""
                                      ) {
                                        setFieldValue(
                                          "first_pickup",
                                          moment(
                                            new Date(
                                              date_closing +
                                              values.com * 24 * 60 * 60 * 1000
                                            )
                                          ).format("YYYY-MM-DD")
                                        );
                                      }
                                    }}
                                  >
                                    <MenuItem value="" disabled>
                                      <em>เลือก วันที่ใช้ในการคำนวณ </em>
                                    </MenuItem>
                                    <MenuItem value="1">
                                      <em>ETA POD </em>
                                    </MenuItem>
                                    <MenuItem value="2">
                                      <em>CLOSING DATE </em>
                                    </MenuItem>
                                  </Select>
                                </FormControl> */}
                                </>
                              ) : null}
                            </div>
                            <h6
                              style={{ marginTop: "10px" }}
                              className="textcolordarkblue"
                            >
                              PICK UP AT POL
                            </h6>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <FormControl sx={{ width: "50%", mr: "5px" }}>
                                <InputLabel>Choose</InputLabel>
                                <Select
                                  name="choose"
                                  label="Choose"
                                  value={values.choose}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={(e) => {
                                    setFieldValue("choose", e.target.value);
                                    setChooseText(e.target.value);
                                  }}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก ประเภทการขนส่ง </em>
                                  </MenuItem>
                                  {groupData.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.GroupId}
                                      >
                                        {option.GroupName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              <FormControl sx={{ width: "50%", mr: "5px" }}>
                                <InputLabel>Empty / Laden</InputLabel>
                                <Select
                                  name="empty_laden"
                                  label="Empty / Laden"
                                  value={values.empty_laden}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="Empty">Empty</MenuItem>
                                  <MenuItem value="Laden">Laden</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <TextField
                                name="first_pickup"
                                label="1ST PICK UP"
                                variant="outlined"
                                placeholder="1ST PICK UP"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ readOnly: true }}
                                value={values.first_pickup}
                                defaultValue={values.first_pickup}
                              />
                              {errors.first_pickup &&
                                touched.first_pickup &&
                                errors.first_pickup}
                              <DesktopDatePicker
                                inputFormat="yyyy-MM-dd"
                                name="actual_pickup"
                                label="Actual PICK UP"
                                value={values.actual_pickup}
                                onChange={(e) => {
                                  const nformat =
                                    moment(e).format("YYYY-MM-DD");

                                  // const mformat = moment(e, "DD/MM/YYYY").format(
                                  //   "YYYY/MM/DD"
                                  // );
                                  // console.log(nformat);

                                  setFieldValue("actual_pickup", nformat);
                                  // setClosingdate(mformat);
                                  // if (
                                  //   values.com != "" &&
                                  //   values.det == "" &&
                                  //   values.dem == "" &&
                                  //   values.choice_com_calculate == "2"
                                  // ) {
                                  //   let date_now = +new Date(nformat);

                                  //   setFieldValue(
                                  //     "first_pickup",
                                  //     moment(
                                  //       new Date(
                                  //         date_now + values.com * 24 * 60 * 60 * 1000
                                  //       )
                                  //     ).format("YYYY-MM-DD")
                                  //   );
                                  // }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    style={{
                                      width: "50%",
                                      marginRight: 5,
                                      marginLeft: 5,
                                    }}
                                    {...params}
                                  />
                                )}
                              />
                              {values.actual_pickup && values.first_pickup ? (
                                <TextField
                                  label="diff"
                                  sx={{
                                    marginRight: 5, "& .MuiInputBase-input": {
                                      color: Math.round(
                                        // Math.abs(
                                        (new Date(values.actual_pickup) - new Date(values.first_pickup))

                                        // ) 
                                        /
                                        1000 /
                                        60 /
                                        60 /
                                        24
                                      ) >= 0 ? '#000' : 'red'
                                    }
                                  }}
                                  value={Math.round(
                                    // Math.abs(
                                    (new Date(values.actual_pickup) - new Date(values.first_pickup))

                                    // ) 
                                    /
                                    1000 /
                                    60 /
                                    60 /
                                    24
                                  )}
                                />
                              ) : (
                                ""
                              )}
                              {values.container_require == 0 ? (
                                <FormControl sx={{ width: "50%", mr: "5px" }}>
                                  <InputLabel>DEPOTS</InputLabel>
                                  <Select
                                    name="depots"
                                    label="DEPOTS"
                                    value={values.depots}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  >
                                    <MenuItem value="" disabled>
                                      <em>เลือก DEPOTS </em>
                                    </MenuItem>

                                    {depots_data.map((option, index) => {
                                      return (
                                        <MenuItem
                                          key={index}
                                          value={option.DepotsId}
                                        >
                                          {option.DepotsName}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              ) : (
                                <FormControl sx={{ width: "50%", mr: "5px" }}>
                                  <InputLabel>DEPOTS</InputLabel>
                                  <Select
                                    name="depots"
                                    label="DEPOTS"
                                    value={values.depots}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled
                                  >
                                    <MenuItem value="">
                                      <em>เลือก DEPOTS </em>
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              )}
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <TextField
                                name="voyage_no"
                                label="VOYAGE NO."
                                variant="outlined"
                                placeholder="VOYAGE NO."
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                  readOnly: true,
                                }}
                                value={voy_no_select}
                              />
                              {errors.voy_no_select &&
                                touched.voy_no_select &&
                                errors.voy_no_select}
                              <Button
                                variant="contained"
                                sx={{ mr: "5px" }}
                                onClick={async () => {
                                  if (
                                    values != null &&
                                    values.choose != null &&
                                    values.choose != "" &&
                                    values.first_pickup != null &&
                                    values.first_pickup != "" &&
                                    values.first_pickup != undefined
                                  ) {
                                    const pickup_f = SaleorderData.PickupFirst
                                      ? SaleorderData.PickupFirst
                                      : "";

                                    const params = {
                                      group: values.choose,
                                      pickupDate:
                                        values.actual_pickup ||
                                        values.first_pickup,
                                      useStockContainer:
                                        values.container_require == 1
                                          ? true
                                          : false,
                                      closingDate: values.closing_date,
                                      closingTime: values.closing_time,
                                      commodityId: values.commodity,
                                      containerTypeId: values.volume_container,
                                      quantity: values.volume_quantity,
                                      countryId: values.conuntrylinerId,
                                    };

                                    try {
                                      const response = await api.post(
                                        "api/master/saleorder/voy",
                                        params
                                      );
                                      setVoyFetch(response.data);
                                      setVoy_DataFilter(response.data);
                                      if (response.data.length != 0) {
                                        setDialog_Voy(true);
                                      }
                                      if (response.data.length == 0) {
                                        const MySwal = withReactContent(Swal);
                                        MySwal.fire({
                                          icon: "info",
                                          didOpen: () => {
                                            MySwal.clickConfirm();
                                          },
                                        }).then(() => {
                                          return MySwal.fire(
                                            "แจ้งเตือน",
                                            "ไม่พบข้อมูลประจำเดือนที่เลือก !",
                                            "info"
                                          );
                                        });
                                      }

                                      // console.log(response.data);
                                    } catch (e) {
                                      const MySwal = withReactContent(Swal);
                                      MySwal.fire({
                                        icon: "error",
                                        didOpen: () => {
                                          MySwal.clickConfirm();
                                        },
                                      }).then(() => {
                                        return MySwal.fire(
                                          "แจ้งเตือน",
                                          "ไม่พบข้อมูล โปรดตรวจสอบอีกครั้ง !",
                                          "error"
                                        );
                                      });
                                      console.log(e);
                                    }
                                  }
                                  if (
                                    values.first_pickup == "" ||
                                    values.choose == ""
                                  ) {
                                    const MySwal = withReactContent(Swal);

                                    MySwal.fire({
                                      icon: "warning",
                                      didOpen: () => {
                                        MySwal.clickConfirm();
                                      },
                                    }).then(() => {
                                      return MySwal.fire(
                                        "แจ้งเตือน",
                                        "โปรดตรวจสอบช่องทางการขนส่ง หรือ รหัส 1ST pickup !",
                                        "warning"
                                      );
                                    });
                                  }
                                }}
                              >
                                Search
                              </Button>
                              <TextField
                                name="mt_etd_pol"
                                label="MT ETD POL"
                                variant="outlined"
                                type="date"
                                placeholder="MT ETD POL"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                value={values.mt_etd_pol}
                              />
                              {errors.mt_etd_pol &&
                                touched.mt_etd_pol &&
                                errors.mt_etd_pol}
                            </div>
                            <hr />
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <h6
                                style={{ marginTop: "10px" }}
                                className="textcolordarkblue"
                              >
                                MT CNTR AT CY STL
                              </h6>
                              <Button
                                type="button"
                                variant="contained"
                                style={{
                                  background: "#80c340",
                                  borderColor: "#80c340",
                                  marginLeft: "10px",
                                }}
                                onClick={() => setMT_CNTR_AT_CY_STL(true)}
                              >
                                <AddIcon /> Add Row
                              </Button>
                            </div>
                            {MT_CNTR_AT_CY_STL_DATA.length > 0 ? (
                              <TableContainer
                                sx={{ marginTop: 2, marginBottom: 2 }}
                              >
                                <Table stickyHeader>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell align="center">#</TableCell>
                                      <TableCell align="center">
                                        Request STL Truck{" "}
                                      </TableCell>
                                      <TableCell align="center">
                                        VOYAGE NO.
                                      </TableCell>
                                      <TableCell align="center">
                                        MT ETA ICD-TS
                                      </TableCell>
                                      <TableCell align="center">
                                        PICK-UP DATE
                                      </TableCell>
                                      <TableCell align="center"></TableCell>
                                    </TableRow>
                                  </TableHead>

                                  {MT_CNTR_AT_CY_STL_DATA.map((data, index) => {
                                    return (
                                      <TableBody>
                                        <TableCell align="center">
                                          {index + 1}
                                        </TableCell>
                                        <TableCell align="center" width="25%">
                                          YES
                                        </TableCell>
                                        <TableCell align="right">
                                          {data.voyNo}
                                        </TableCell>
                                        <TableCell align="right">
                                          {data.mtEta}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          sx={{
                                            color:
                                              data.mtPick > date1st
                                                ? "red"
                                                : "#000000",
                                          }}
                                        >
                                          {data.mtPick}
                                        </TableCell>
                                        <TableCell align="right">
                                          {" "}
                                          <Button
                                            onClick={() =>
                                              delete_mt_stel(index)
                                            }
                                          >
                                            Delete
                                          </Button>
                                        </TableCell>
                                      </TableBody>
                                    );
                                  })}
                                </Table>
                              </TableContainer>
                            ) : null}
                            <hr />
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <h6
                                style={{ marginTop: "10px" }}
                                className="textcolordarkblue"
                              >
                                STUFFING PLAN
                              </h6>
                              <Button
                                type="button"
                                variant="contained"
                                style={{
                                  background: "#80c340",
                                  borderColor: "#80c340",
                                  marginLeft: "10px",
                                }}
                                onClick={() => setSTUFFING_PLAN(true)}
                              >
                                <AddIcon /> Add Row
                              </Button>
                            </div>
                            {plan_data.length > 0 ? (
                              <TableContainer
                                sx={{ marginTop: 2, marginBottom: 2 }}
                              >
                                <Table stickyHeader>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell align="center">#</TableCell>
                                      <TableCell align="center">
                                        DATE{" "}
                                      </TableCell>
                                      <TableCell align="center">
                                        FACTORY
                                      </TableCell>
                                      {/* <TableCell align="center">Container</TableCell>
                                <TableCell align="center">Quantity</TableCell>
                                <TableCell align="center">CANCEL</TableCell> */}
                                      <TableCell align="center"></TableCell>
                                    </TableRow>
                                  </TableHead>
                                  {plan_data.map((data, index) => {
                                    return (
                                      <TableBody>
                                        <TableCell align="center">
                                          {index + 1}
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          width="25%"
                                          sx={{
                                            color:
                                              data.spDate < plandate
                                                ? "red"
                                                : "#000000",
                                          }}
                                        >
                                          {data.spDate}
                                        </TableCell>
                                        <TableCell align="right">
                                          {data.spFactory}
                                        </TableCell>
                                        {/* <TableCell align="right">
                                    {container_data.map((res) => {
                                      // console.log(res.GroupId);
                                      if (
                                        res.ContainerTypeId == data.containerId
                                      ) {
                                        return res.ContainerTypeName;
                                      }
                                    })}
                                  </TableCell>
                                  <TableCell align="right">
                                    {data.qty}
                                  </TableCell>
                                  <TableCell align="right">
                                    {data.spCancel}
                                  </TableCell> */}
                                        <TableCell align="right">
                                          <Button
                                            onClick={() =>
                                              delete_stuffing_plan(index)
                                            }
                                          >
                                            Delete
                                          </Button>
                                        </TableCell>
                                      </TableBody>
                                    );
                                  })}
                                </Table>
                              </TableContainer>
                            ) : null}
                            <hr />
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <h6
                                style={{ marginTop: "10px" }}
                                className="textcolordarkblue"
                              >
                                LADEN CNTR
                              </h6>
                              <Button
                                type="button"
                                variant="contained"
                                style={{
                                  background: "#80c340",
                                  borderColor: "#80c340",
                                  marginLeft: "10px",
                                }}
                                onClick={() => setLADEN_CNTR(true)}
                              >
                                <AddIcon /> Add Row
                              </Button>
                            </div>
                            {laden_data.length > 0 ? (
                              <TableContainer
                                sx={{ marginTop: 2, marginBottom: 2 }}
                              >
                                <Table stickyHeader>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell align="center">#</TableCell>
                                      <TableCell align="center">
                                        Choose{" "}
                                      </TableCell>
                                      <TableCell align="center">
                                        VOYAGE NO.
                                      </TableCell>
                                      <TableCell align="center">
                                        LADEN ETD ICD-TS (DATE)
                                      </TableCell>

                                      <TableCell align="center"></TableCell>
                                    </TableRow>
                                  </TableHead>
                                  {laden_data.map((data, index) => {
                                    return (
                                      <TableBody>
                                        <TableCell align="center">
                                          {index + 1}
                                        </TableCell>
                                        <TableCell align="center" width="25%">
                                          {/* {data.choose} */}
                                          {groupData.map((res) => {
                                            // console.log(res.GroupId);
                                            if (res.GroupId == data.choose) {
                                              return res.GroupName;
                                            }
                                          })}
                                        </TableCell>
                                        <TableCell align="right">
                                          {data.voyNo}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          sx={{
                                            color:
                                              data.etdDate < plandate
                                                ? "red"
                                                : "#000000",
                                          }}
                                        >
                                          {data.etdDate}
                                        </TableCell>

                                        <TableCell align="right">
                                          {" "}
                                          <Button
                                            onClick={() => delete_laden(index)}
                                          >
                                            Delete
                                          </Button>
                                        </TableCell>
                                      </TableBody>
                                    );
                                  })}
                                </Table>
                              </TableContainer>
                            ) : null}
                            <hr />
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <TextField
                                name="return_date"
                                label="RETURN DATE"
                                variant="outlined"
                                type="date"
                                placeholder="RETURN DATE"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                value={values.return_date}
                                defaultValue={values.return_date}
                              />
                              {errors.return_date &&
                                touched.return_date &&
                                errors.return_date}

                              <DesktopDatePicker
                                inputFormat="dd/MM/yyyy"
                                name="actual_return_date"
                                label="ACTUAL RETURN DATE *"
                                value={values.actual_return_date}
                                onChange={(e) => {
                                  const nformat =
                                    moment(e).format("YYYY-MM-DD");
                                  // console.log(nformat);

                                  setFieldValue("actual_return_date", nformat);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    style={{ width: "50%", marginRight: 5 }}
                                    {...params}
                                  />
                                )}
                              />
                              {values.actual_return_date &&
                                values.return_date ? (
                                <TextField
                                  label="diff"
                                  sx={{
                                    marginRight: 5, "& .MuiInputBase-input": {
                                      color: Math.round(
                                        // Math.abs(
                                        (new Date(values.actual_return_date) - new Date(values.return_date))

                                        // ) 
                                        /
                                        1000 /
                                        60 /
                                        60 /
                                        24
                                      ) >= 0 ? '#000' : 'red'
                                    }
                                  }}
                                  value={Math.round(
                                    (
                                      new Date(values.actual_return_date) - new Date(values.return_date)
                                    ) /
                                    1000 /
                                    60 /
                                    60 /
                                    24
                                  )}
                                />
                              ) : (
                                ""
                              )}
                              <FormControl sx={{ width: "50%", mr: "5px" }}>
                                <InputLabel>TERMINALS</InputLabel>
                                <Select
                                  name="terminals"
                                  label="TERMINALS"
                                  value={values.terminals}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก TERMINALS </em>
                                  </MenuItem>
                                  {terminal_data.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.TerminalId}
                                      >
                                        {option.TerminalName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <FormControl sx={{ width: "25%", mr: "5px" }}>
                                <InputLabel>Country</InputLabel>
                                <Select
                                  name="conuntry"
                                  label="Country"
                                  value={values.conuntry}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก Country </em>
                                  </MenuItem>
                                  {country_fetch_data.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.CountryId}
                                      >
                                        {option.CountryName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              <FormControl sx={{ width: "25%", mr: "5px" }}>
                                <InputLabel>PORT OF DISCHARGE</InputLabel>
                                <Select
                                  name="port_of_discharge"
                                  label="PORT OF DISCHARGE"
                                  value={values.port_of_discharge}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก PORT OF DISCHARGE </em>
                                  </MenuItem>
                                  {polpod_fetch_data.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.PolPodId}
                                      >
                                        {option.PolPodName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              <FormControl sx={{ width: "50%", mr: "5px" }}>
                                <InputLabel>POD TERMINAL</InputLabel>
                                <Select
                                  name="pod_terminal"
                                  label="POD TERMINAL"
                                  value={values.pod_terminal}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก POD TERMINAL </em>
                                  </MenuItem>
                                  {polpod_fetch_data.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.PolPodId}
                                      >
                                        {option.PolPodName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <TextField
                                name="first_vissel"
                                label="1ST VESSEL"
                                variant="outlined"
                                placeholder="1ST VESSEL"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                value={values.first_vissel}
                              />
                              {errors.email && touched.email && errors.email}
                              <FormControl sx={{ width: "50%" }}>
                                <InputLabel>TRANSHIPMENT</InputLabel>
                                <Select
                                  name="first_vissel_transshipment"
                                  label="TRANSHIPMENT"
                                  value={values.first_vissel_transshipment}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก TRANSSHIPMENT </em>
                                  </MenuItem>
                                  {transshipment_fetch_data.map(
                                    (option, index) => {
                                      return (
                                        <MenuItem
                                          key={index}
                                          value={option.TransshipmentId}
                                        >
                                          {option.TransshipmentName}
                                        </MenuItem>
                                      );
                                    }
                                  )}
                                </Select>
                              </FormControl>
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <TextField
                                name="second_vissel"
                                label="2ND VESSEL"
                                variant="outlined"
                                placeholder="2ND VESSEL"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                value={values.second_vissel}
                              />
                              {errors.email && touched.email && errors.email}
                              <FormControl sx={{ width: "50%" }}>
                                <InputLabel>TRANSHIPMENT</InputLabel>
                                <Select
                                  name="second_vissel_transshipment"
                                  label="TRANSHIPMENT"
                                  value={values.second_vissel_transshipment}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก TRANSSHIPMENT </em>
                                  </MenuItem>
                                  {transshipment_fetch_data.map(
                                    (option, index) => {
                                      return (
                                        <MenuItem
                                          key={index}
                                          value={option.TransshipmentId}
                                        >
                                          {option.TransshipmentName}
                                        </MenuItem>
                                      );
                                    }
                                  )}
                                </Select>
                              </FormControl>
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <TextField
                                name="third_vissel"
                                label="3RD VESSEL"
                                variant="outlined"
                                placeholder="3RD VESSEL"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                value={values.third_vissel}
                              />
                              {errors.email && touched.email && errors.email}
                              <FormControl sx={{ width: "50%" }}>
                                <InputLabel>TRANSHIPMENT</InputLabel>
                                <Select
                                  name="third_vissel_transshipment"
                                  label="TRANSHIPMENT"
                                  value={values.third_vissel_transshipment}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก TRANSSHIPMENT </em>
                                  </MenuItem>
                                  {transshipment_fetch_data.map(
                                    (option, index) => {
                                      return (
                                        <MenuItem
                                          key={index}
                                          value={option.TransshipmentId}
                                        >
                                          {option.TransshipmentName}
                                        </MenuItem>
                                      );
                                    }
                                  )}
                                </Select>
                              </FormControl>
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <FormControl
                                style={{ width: "50%", marginRight: 5 }}
                              >
                                <InputLabel>INCO TERMS</InputLabel>
                                <Select
                                  name="inco_terms"
                                  label="INCO TERMS"
                                  value={values.inco_terms}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  disabled={values.freight_terms !== ""}
                                >
                                  <MenuItem value="">
                                    <em>เลือก INCO TERMS </em>
                                  </MenuItem>
                                  {incoterm_data.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.IncotermsId}
                                      >
                                        {option.IncotermName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>

                              <FormControl sx={{ width: "50%" }}>
                                <InputLabel>FREIGHT TERMS</InputLabel>
                                <Select
                                  name="freight_terms"
                                  label="FREIGHT TERMS"
                                  value={values.freight_terms}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  disabled={values.inco_terms !== ""}
                                >
                                  <MenuItem value="" disabled>
                                    <em>เลือก FREIGHT TERMS </em>
                                  </MenuItem>
                                  {terms_fetch_data.map((option, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={option.FreightTermsId}
                                      >
                                        {option.FreightTermsName}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <TextField
                                name="eta_pod"
                                label="ETA POD"
                                variant="outlined"
                                InputProps={{
                                  inputProps: {
                                    min: Date.now(),
                                  },
                                }}
                                type="date"
                                placeholder="ETA POD"
                                onChange={(e) => {
                                  setFieldValue("eta_pod", e.target.value);
                                  if (
                                    values.com != "" &&
                                    values.det == "" &&
                                    values.dem == "" &&
                                    values.choice_com_calculate == "1"
                                  ) {
                                    let date_now = +new Date(e.target.value);
                                    let com_value = -values.com + 1;
                                    setFieldValue(
                                      "first_pickup",
                                      moment(
                                        new Date(
                                          date_now +
                                          com_value * 24 * 60 * 60 * 1000
                                        )
                                      ).format("YYYY-MM-DD")
                                    );
                                  }
                                }}
                                onBlur={handleBlur}
                                sx={{
                                  width: "100%",
                                  "& .MuiInputBase-input": {
                                    color:
                                      laden_etdDate !== "Invalid date"
                                        ? values.eta_pod > laden_etdDate
                                          ? "red"
                                          : "#000"
                                        : spDate !== "Invalid date"
                                        ? values.eta_pod > spDate
                                          ? "red"
                                          : "#000"
                                        : datemt !== "Invalid date"
                                        ? values.eta_pod > datemt
                                          ? "red"
                                          : "#000"
                                        : values.eta_pod >
                                          values.actual_return_date
                                        ? "red"
                                        : "#000",
                                  },
                                }}
                                InputLabelProps={{ shrink: true }}
                                value={values.eta_pod}
                              />
                              {errors.eta_pod &&
                                touched.eta_pod &&
                                errors.eta_pod}
                              {/* <TextField
                          name="consig_time"
                          label="CONSIG TIME"
                          variant="outlined"
                          placeholder="CONSIG TIME"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={values.consig_time}
                        />
                        {errors.consig_time &&
                          touched.consig_time &&
                          errors.consig_time} */}
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <TextField
                                name="cut_off_si"
                                label="CUT-OFF SI"
                                variant="outlined"
                                type="datetime-local"
                                placeholder="CUT-OFF SI"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                value={values.cut_off_si}
                              />
                              {errors.cut_off_si &&
                                touched.cut_off_si &&
                                errors.cut_off_si}
                              <TextField
                                name="cut_off_vgm"
                                label="CUT-OFF VGM"
                                type="datetime-local"
                                variant="outlined"
                                placeholder="CUT-OFF VGM"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ width: "50%", marginRight: 5 }}
                                InputLabelProps={{ shrink: true }}
                                value={values.cut_off_vgm}
                              />
                              {errors.cut_off_vgm &&
                                touched.cut_off_vgm &&
                                errors.cut_off_vgm}
                            </div>
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <FormControl sx={{ width: "50%", mr: "5px" }}>
                                <InputLabel>FUMIGATION</InputLabel>
                                <Select
                                  name="fumigation"
                                  label="FUMIGATION"
                                  value={values.fumigation}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="y">Yes</MenuItem>
                                  <MenuItem value="n">No</MenuItem>
                                </Select>
                              </FormControl>
                              <FormControl sx={{ width: "50%" }}>
                                <InputLabel>PHYTO CERT</InputLabel>
                                <Select
                                  name="phyto_cert"
                                  label="PHYTO CERT"
                                  value={values.phyto_cert}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="y">Yes</MenuItem>
                                  <MenuItem value="n">No</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                            {values.fumigation == "y" ? (
                              <div>
                                <div style={{ marginTop: 10 }}>
                                  <TextField
                                    name="fumigation_remark"
                                    label="FUMIGATION Remark"
                                    variant="outlined"
                                    placeholder="FUMIGATION Remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={values.fumigation_remark}
                                  />
                                  {errors.fumigation_remark &&
                                    touched.fumigation_remark &&
                                    errors.fumigation_remark}
                                </div>
                              </div>
                            ) : null}
                            {values.phyto_cert == "y" ? (
                              <div>
                                <div style={{ marginTop: 10 }}>
                                  <TextField
                                    name="phyto_cert_remark"
                                    label="PHYTO CERT Remark"
                                    variant="outlined"
                                    placeholder="PHYTO CERT Remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={values.phyto_cert_remark}
                                  />
                                  {errors.phyto_cert_remark &&
                                    touched.phyto_cert_remark &&
                                    errors.phyto_cert_remark}
                                </div>
                              </div>
                            ) : null}
                            <div style={{ display: "flex", marginTop: 10 }}>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="doc_mt"
                                      value={values.doc_mt === 1 ? true : false}
                                      checked={
                                        values.doc_mt === 1 ? true : false
                                      }
                                      onClick={(e) => {
                                        setFieldValue(
                                          "doc_mt",
                                          e.target.checked ? 1 : 0
                                        );
                                        // console.log(values);
                                      }}
                                    />
                                  }
                                  label="MT"
                                />
                              </FormGroup>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      value={
                                        values.doc_cntr === 1 ? true : false
                                      }
                                      checked={
                                        values.doc_cntr === 1 ? true : false
                                      }
                                      onClick={(e) => {
                                        setFieldValue(
                                          "doc_cntr",
                                          e.target.checked ? 1 : 0
                                        );
                                        // console.log(values);
                                      }}
                                    />
                                  }
                                  label="Cntr"
                                />
                              </FormGroup>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      value={
                                        values.doc_inv === 1 ? true : false
                                      }
                                      checked={
                                        values.doc_inv === 1 ? true : false
                                      }
                                      onClick={(e) => {
                                        setFieldValue(
                                          "doc_inv",
                                          e.target.checked ? 1 : 0
                                        );
                                        // console.log(values);
                                      }}
                                    />
                                  }
                                  label="Inv"
                                />
                              </FormGroup>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      value={
                                        values.doc_export === 1 ? true : false
                                      }
                                      checked={
                                        values.doc_export === 1 ? true : false
                                      }
                                      onClick={(e) => {
                                        setFieldValue(
                                          "doc_export",
                                          e.target.checked ? 1 : 0
                                        );
                                        // console.log(values);
                                      }}
                                    />
                                  }
                                  label="Export"
                                />
                              </FormGroup>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      value={values.doc_si === 1 ? true : false}
                                      checked={
                                        values.doc_si === 1 ? true : false
                                      }
                                      onClick={(e) => {
                                        setFieldValue(
                                          "doc_si",
                                          e.target.checked ? 1 : 0
                                        );
                                        // console.log(values);
                                      }}
                                    />
                                  }
                                  label="SI"
                                />
                              </FormGroup>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      value={
                                        values.doc_vmg === 1 ? true : false
                                      }
                                      checked={
                                        values.doc_vmg === 1 ? true : false
                                      }
                                      onClick={(e) => {
                                        setFieldValue(
                                          "doc_vmg",
                                          e.target.checked ? 1 : 0
                                        );
                                        // console.log(values);
                                      }}
                                    />
                                  }
                                  label="VMG"
                                />
                              </FormGroup>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      value={
                                        values.doc_carco === 1 ? true : false
                                      }
                                      checked={
                                        values.doc_carco === 1 ? true : false
                                      }
                                      onClick={(e) => {
                                        setFieldValue(
                                          "doc_carco",
                                          e.target.checked ? 1 : 0
                                        );
                                        // console.log(values);
                                      }}
                                    />
                                  }
                                  label="CARCO"
                                />
                              </FormGroup>
                            </div>
                          </Grid>
                        </Grid>
                        <div style={{ display: "flex" , marginTop: 10 }}>
                          <Button
                            type="button"
                            variant="outlined"
                            style={{
                              color: "#80c340",
                              borderColor: "#80c340",
                              marginRight: "10px",
                            }}
                            onClick={history.goBack}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="contained"
                            style={{
                              background: "#80c340",
                              borderColor: "#80c340",
                              marginRight: "10px",
                              color: "#FFF",
                            }}
                            onClick={() => setDiremark(true)}
                            // disabled={isSubmitting}
                          >
                            {/* {isSubmitting && <CircularProgress size={22} />}
                            {!isSubmitting && "SAVE"} */}
                            SAVE
                          </Button>
                          <Dialog fullWidth="sm" open={diremark}>
                            <DialogTitle>Remark</DialogTitle>
                            <Box></Box>
                            <DialogContent>
                              <TextField
                                autoFocus
                                name="RemarkLog"
                                label="Remark"
                                fullWidth
                                color="success"
                                variant="outlined"
                                onChange={(r) => setremarkLog(r.target.value)}
                              />
                              <DialogActions
                                sx={{
                                  marginTop: "24px",
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <form onSubmit={() => setDiremark(false)}>
                                  
                                  <Button
                                    type="button"
                                    variant="outlined"
                                    style={{
                                      color: "#80c340",
                                      borderColor: "#80c340",
                                      marginRight: "10px",
                                    }}
                                    onClick={handleCloseremark}
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    variant="contained"
                                    type="submit"
                                    style={{
                                      background: remarklog ? "#80c340":'gray',
                                      borderColor:  "#80c340",
                                      marginRight: "10px",
                                      color: "#FFF",
                                    }}
                                    disabled={!remarklog ? true : false}
                                  >
                                    Submit
                                  </Button>
                                </form>
                              </DialogActions>
                            </DialogContent>
                          </Dialog>
                          <Button
                            variant="outlined"
                            style={{
                              background: "#fff",
                              borderColor: "#C8C8C8",
                            }}
                          >
                            <a
                              href={
                                process.env.REACT_APP_BASE_API +
                                "/" +
                                pdfFileGen
                              }
                              target="_blank"
                            >
                              <Typography sx={{ color: "#8E8C8C" }}>
                                Print
                              </Typography>
                            </a>
                          </Button>
                        </div>
                      </form>
                    )}
                  </Formik>
                </Grid>
                {/* <Grid item xs={3}>
                  <Card>
                    <CardHeader
                      title="LOG STATUS"
                      sx={{
                        backgroundColor: "#007BFF",
                        color: "white",
                        alignContent: "center",
                        textAlign: "center",
                      }}
                    />

                    <CardContent>
                      {log_data.slice(0, log_data_length).map((x) => (
                        <>
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <Typography>{x.TypeName}</Typography>

                              <Typography>{x.EmpName}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography>{x.Remark}</Typography>

                              <Typography>
                              
                                {moment
                                  .utc(x.CreateDate)
                                  .local()
                                  .startOf("seconds")
                                  .fromNow()}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                        </>
                      ))}
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        {see_moreData ? (
                          <Button
                            variant="contained"
                            onClick={() => {
                              setSeemore_data(false);
                              setLog_data_length(3);
                            }}
                            sx={{ mt: 1 }}
                          >
                            Hide
                          </Button>
                        ) : (
                          <Button
                            onClick={() => {
                              setSeemore_data(true);
                              setLog_data_length(log_data.length);
                            }}
                            variant="contained"
                            sx={{ mt: 1 }}
                          >
                            See more
                          </Button>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid> */}
              </Grid>
            </TabPanel>

            <TabPanel value="2">
              <Formik
                enableReinitialize
                initialValues={{
                  ocean_freight: payment_data.OceanFreight
                    ? payment_data.OceanFreight
                    : "",
                  thc_free: payment_data.Thc ? payment_data.Thc : "",
                  bl_free: payment_data.BLfee ? payment_data.BLfee : "",
                  edi_free: payment_data.Edi ? payment_data.Edi : "",
                  seal_free: payment_data.SealFee ? payment_data.SealFee : "",
                  trucking_free: payment_data.TruckingFee
                    ? payment_data.TruckingFee
                    : "",
                  grand_total: payment_data.GrandTotal
                    ? payment_data.GrandTotal
                    : "",
                  wbs: payment_data.Wbs ? payment_data.Wbs : "",
                  cur_ocean: payment_data.Cur_Ocean
                    ? payment_data.Cur_Ocean
                    : "",
                  cur_wbs: payment_data.Cur_Wbs ? payment_data.Cur_Wbs : "",
                  cur_thc: payment_data.Cur_Thc ? payment_data.Cur_Thc : "",
                  cur_edi: payment_data.Cur_Edi ? payment_data.Cur_Edi : "",
                  cur_seal: payment_data.Cur_Seal ? payment_data.Cur_Seal : "",
                  cur_trucking: payment_data.Cur_Truck
                    ? payment_data.Cur_Truck
                    : "",
                  cur_bl: payment_data.Cur_BL ? payment_data.Cur_BL : "",
                  RemarkLog: "",
                }}
                validate={(values) => {
                  const errors = {};
                  // if (!values.customer_code || values.customer_code === "") {
                  //   errors.customer_code = "Required";
                  // }
                  return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                  setTimeout(() => {
                    if (payment_data.length === 0) {
                      const data = {
                        soId: SaleorderData.SoId,
                        ocean: values.ocean_freight,
                        thc: values.thc_free,
                        blFee: values.bl_free,
                        edi: values.edi_free,
                        sealFee: values.seal_free,
                        truckingFee: values.trucking_free,
                        grandTotal: 0,
                        wbs: values.wbs,
                        curOcean: values.cur_ocean,
                        curWbs: values.cur_wbs,
                        curThc: values.cur_thc,
                        curEdi: values.cur_edi,
                        curSeal: values.cur_seal,
                        curTruck: values.cur_trucking,
                        curBL: values.cur_bl,
                        createId: EmpId,
                      };

                      api
                        .post("api/saleorder/payment/create", data)
                        .then((respose) => {
                          const MySwal = withReactContent(Swal);

                          MySwal.fire({
                            icon: "success",
                            didOpen: () => {
                              MySwal.clickConfirm();
                            },
                          }).then(() => {
                            return MySwal.fire(
                              "สำเร็จ!",
                              "เพิ่ม Payment สำเร็จ !",
                              "success"
                            );
                          });
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    } else {
                      const data = {
                        id: payment_data.PaymentId,
                        soId: SaleorderData.SoId,
                        ocean: values.ocean_freight,
                        thc: values.thc_free,
                        blFee: values.bl_free,
                        edi: values.edi_free,
                        sealFee: values.seal_free,
                        truckingFee: values.trucking_free,
                        grandTotal: 0,
                        wbs: values.wbs,
                        curOcean: values.cur_ocean,
                        curWbs: values.cur_wbs,
                        curThc: values.cur_thc,
                        curEdi: values.cur_edi,
                        curSeal: values.cur_seal,
                        curTruck: values.cur_trucking,
                        curBL: values.cur_bl,
                        ModId: EmpId,
                        RemarkLog: remarklog,
                      };

                      api
                        .post("api/saleorder/payment/update", data)
                        .then((respose) => {
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    }

                    //   alert(JSON.stringify(values, null, 2));
                    setSubmitting(false);
                  }, 400);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  /* and other goodies */
                }) => (
                  <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
                    <Grid container>
                      <Grid item xs={12} md={12}>
                        <h6
                          style={{ marginTop: "10px" }}
                          className="textcolordarkblue"
                        >
                          Payment
                        </h6>

                        <div style={{ display: "flex", marginTop: 10 }}>
                          <TextField
                            name="ocean_freight"
                            label="Ocean Freight"
                            variant="outlined"
                            placeholder="Ocean Freight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.ocean_freight}
                          />
                          {errors.ocean_freight &&
                            touched.ocean_freight &&
                            errors.ocean_freight}
                          <TextField
                            name="cur_ocean"
                            label="Currency"
                            variant="outlined"
                            placeholder="Currency"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.cur_ocean}
                          />
                          {errors.cur_ocean &&
                            touched.cur_ocean &&
                            errors.cur_ocean}

                          <TextField
                            name="wbs"
                            label="WBS"
                            variant="outlined"
                            placeholder="WBS"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.wbs}
                          />
                          {errors.wbs && touched.wbs && errors.wbs}
                          <TextField
                            name="cur_wbs"
                            label="Currency"
                            variant="outlined"
                            placeholder="Currency "
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.cur_wbs}
                          />
                          {errors.cur_wbs && touched.cur_wbs && errors.cur_wbs}
                        </div>

                        <div style={{ display: "flex", marginTop: 10 }}>
                          <TextField
                            name="thc_free"
                            label="THC FEE"
                            variant="outlined"
                            placeholder="THC FEE"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.thc_free}
                          />
                          {errors.thc_free &&
                            touched.thc_free &&
                            errors.thc_free}
                          <TextField
                            name="cur_thc"
                            label="Currency"
                            variant="outlined"
                            placeholder="Currency"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.cur_thc}
                          />
                          {errors.cur_thc && touched.cur_thc && errors.cur_thc}
                          <TextField
                            name="edi_free"
                            label="EDI FEE"
                            variant="outlined"
                            placeholder="EDI FEE"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.edi_free}
                          />
                          {errors.edi_free &&
                            touched.edi_free &&
                            errors.edi_free}
                          <TextField
                            name="cur_edi"
                            label="Currency"
                            variant="outlined"
                            placeholder="Currency"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.cur_edi}
                          />
                          {errors.cur_edi && touched.cur_edi && errors.cur_edi}
                        </div>
                        <div style={{ display: "flex", marginTop: 10 }}>
                          <TextField
                            name="seal_free"
                            label="SEAL FEE"
                            variant="outlined"
                            placeholder="SEAL FEE"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.seal_free}
                          />
                          {errors.seal_free &&
                            touched.seal_free &&
                            errors.seal_free}
                          <TextField
                            name="cur_seal"
                            label="Currency"
                            variant="outlined"
                            placeholder="Currency"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.cur_seal}
                          />
                          {errors.cur_seal &&
                            touched.cur_seal &&
                            errors.cur_seal}

                          <TextField
                            name="trucking_free"
                            label="Trucking FEE"
                            variant="outlined"
                            placeholder="Trucking FEE"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{ width: "50%", marginRight: 5 }}
                            InputLabelProps={{ shrink: true }}
                            value={values.trucking_free}
                          />
                          {errors.trucking_free &&
                            touched.trucking_free &&
                            errors.trucking_free}
                          <TextField
                            name="cur_trucking"
                            label="Currency"
                            variant="outlined"
                            placeholder="Currency"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.cur_trucking}
                          />
                          {errors.cur_trucking &&
                            touched.cur_trucking &&
                            errors.cur_trucking}
                        </div>
                        <div style={{ marginTop: 10, display: "flex" }}>
                          <TextField
                            name="bl_free"
                            label="B/L FEE"
                            variant="outlined"
                            placeholder="B/L FEE"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{ width: "50%", marginRight: 5 }}
                            InputLabelProps={{ shrink: true }}
                            value={values.bl_free}
                          />
                          {errors.bl_free && touched.bl_free && errors.bl_free}
                          <TextField
                            name="cur_bl"
                            label="Currency"
                            variant="outlined"
                            placeholder="Currency"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.cur_bl}
                          />
                          {errors.cur_bl && touched.cur_bl && errors.cur_bl}
                        </div>
                      </Grid>
                    </Grid>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <Button
                        type="button"
                        variant="outlined"
                        style={{
                          color: "#80c340",
                          borderColor: "#80c340",
                          marginRight: "10px",
                        }}
                        onClick={history.goBack}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        style={{
                          background: "#80c340",
                          borderColor: "#80c340",
                          marginRight: "10px",
                        }}
                        disabled={isSubmitting}
                      >
                        {isSubmitting && <CircularProgress size={22} />}
                        {!isSubmitting && "SAVE"}
                      </Button>
                    </div>
                  </form>
                )}
              </Formik>
            </TabPanel>
            <TabPanel value="3"></TabPanel>
            <TabPanel value="4">
              {" "}
              <Grid
                style={{
                  marginTop: "10px",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  {/* {console.log(uniqueContainerSizeTotal)} */}
                  {uniqueContainerSizeTotal.length > 0
                    ? uniqueContainerSizeHeader.map((res, index) => {
                      return (
                        <Box
                          style={{
                            backgroundColor: "#30318D",
                            color: "white",
                            borderRadius: "5px",
                            whiteSpace: "nowrap",
                            margin: "5px",
                            padding: "5px",
                          }}
                        >
                          {/* {console.log(uniqueContainerSizeHeader[index])} */}
                          Total Size {uniqueContainerSizeHeader[index]} '
                          <text
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              borderRadius: "5px",
                              margin: "5px",
                              padding: "5px",
                            }}
                          >
                            {
                              uniqueContainerSizeTotal.map((res, i) => {
                                // console.log(
                                //   res[uniqueContainerSizeHeader[index]]
                                // );
                                return res[uniqueContainerSizeHeader[index]];
                              })
                              // res[uniqueContainerSizeTotal[index]]
                            }
                          </text>
                        </Box>
                      );
                    })
                    : null}
                </Box>
                <SearchData
                  name={dataContainerList}
                  onsetData={setDataFilterContainerList}
                />
              </Grid>
              <Box
                sx={{
                  height: 400,
                  width: "100%",
                  marginTop: "10px",
                  "& .Active": {
                    color: "#28A745",
                  },
                  "& .Inactive": {
                    color: "#F53C56",
                  },
                }}
              >
                <DataGrid
                  getRowId={(r) => r.ContainerNo}
                  rows={dataFilterContainerList}
                  columns={columnsContainerList}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  hideFooterSelectedRowCount
                  disableColumnFilter
                  disableColumnMenu
                  getCellClassName={(params) => {
                    if (params.field === "Status") {
                      return params.value == 1 ? "Active" : "Inactive";
                    }
                  }}
                />
              </Box>
            </TabPanel>
            <TabPanel value="5">
              <h5 style={{ marginTop: "10px" }} className="textcolordarkblue">
                Tag Error
              </h5>
              <div style={{ marginTop: 10, display: "flex" }}>
                {TagErrorData.length > 0 ? (
                  <div>
                    {TagErrorData.map((data, index) => {
                      return data.RefTagId == "" ? (
                        <div>
                          <Card sx={{ minWidth: 400, marginRight: 5 }}>
                            <ReplayIcon
                              style={{ float: "right", margin: 5 }}
                              onClick={() => {
                                setRefTagErrorID(data.TagId);
                              }}
                            />
                            <CardContent>{data.Remark}</CardContent>
                            <CardActions disableSpacing>
                              {data.CreateDate}
                              โดย
                            </CardActions>
                          </Card>
                        </div>
                      ) : (
                        <Card
                          sx={{
                            minWidth: 400,
                            marginRight: 5,
                            marginLeft: 3,
                            marginTop: 2,
                          }}
                        >
                          <CardContent>{data.Remark}</CardContent>
                          <CardActions disableSpacing>
                            {data.CreateDate}
                            โดย
                          </CardActions>
                        </Card>
                      );
                    })}
                  </div>
                ) : null}

                <Formik
                  enableReinitialize
                  initialValues={{ status: 1, remark: "" }}
                  validate={(values) => {
                    const errors = {};
                    return errors;
                  }}
                  onSubmit={(values, { setSubmitting, setFieldValue }) => {
                    setTimeout(() => {
                      const data = {
                        refTagId: refTagErrorId,
                        remark: values.remark,
                        soId: SaleorderData.SoId,
                        status: values.status,
                        createId: EmpId,
                      };

                      // console.log(data);

                      api
                        .post("api/tagerror/create", data)
                        .then((respose) => {
                          const MySwal = withReactContent(Swal);

                          MySwal.fire({
                            icon: "success",
                            didOpen: () => {
                              MySwal.clickConfirm();
                            },
                          }).then(() => {
                            return MySwal.fire(
                              "สำเร็จ!",
                              "เพิ่ม Tag Error สำเร็จ !",
                              "success"
                            ).then((result) => {
                              if (result.isConfirmed) {
                                setFieldValue("remark", "");
                                setValue("5");
                                GetTagError();
                              }
                            });
                          });
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                      setSubmitting(false);
                    }, 400);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                    /* and other goodies */
                  }) => (
                    <form onSubmit={handleSubmit}>
                      {refTagErrorId != "" ? (
                        <div style={{ display: "flex", marginBottom: 10 }}>
                          <TextField
                            sx={{ mr: "5px" }}
                            fullWidth
                            label="รหัสอ้างอิงตอบกลับ"
                            variant="outlined"
                            value={refTagErrorId}
                            disabled
                          />
                          <Button
                            type="button"
                            variant="contained"
                            style={{
                              color: "white",
                              borderColor: "white",
                              backgroundColor: "#E74C3C",
                              marginBottom: 10,
                            }}
                            onClick={() => {
                              setRefTagErrorID("");
                            }}
                          >
                            ลบ
                          </Button>
                        </div>
                      ) : null}
                      <FormControl fullWidth>
                        <InputLabel>Status</InputLabel>
                        <Select
                          name="status"
                          value={values.status}
                          label="Status"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value={1}>High Priority</MenuItem>
                          <MenuItem value={0}>Low Priority</MenuItem>
                        </Select>
                      </FormControl>
                      <TextField
                        style={{ marginTop: 10 }}
                        rows={3}
                        multiline
                        fullWidth
                        name="remark"
                        label="Remark*"
                        variant="outlined"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.remark}
                      />
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <Button
                          type="button"
                          variant="outlined"
                          style={{
                            color: "#80c340",
                            borderColor: "#80c340",
                            marginRight: "10px",
                          }}
                          onClick={history.goBack}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          variant="contained"
                          style={{
                            background: "#80c340",
                            borderColor: "#80c340",
                            marginRight: "10px",
                          }}
                          disabled={isSubmitting}
                        >
                          {isSubmitting && <CircularProgress size={22} />}
                          {!isSubmitting && "SAVE"}
                        </Button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </TabPanel>
            <TabPanel value="6">
              <h5 style={{ marginTop: "10px" }} className="textcolordarkblue">
                อัพโหลดสำเนาเอกสาร
              </h5>
              <br />
              <label>(ไฟล์ที่ยอมรับ .pdf, .doc , .xls )</label>
              <div style={{ marginTop: 10 }}>
                <label htmlFor="contained-button-file">
                  <Input
                    accept="application/doc,application/pdf,application/vnd.ms-excel"
                    id="contained-button-file"
                    multiple
                    type="file"
                    onChange={(e) => {
                      if (e.target.files[0].length !== 0) {
                        setFileData(e.target.files[0]);
                      } else {
                        const MySwal = withReactContent(Swal);

                        MySwal.fire(
                          "กรุณาตรวจสอบไฟล์!",
                          "กรุณาเลือกไฟล์อัพโหลด .PDF .DOC .XLS เท่านั้น !",
                          "info"
                        );
                      }
                      // console.log(e.target.files[0]);
                    }}
                  />
                  <Button variant="contained" color="primary" component="span">
                    {/* {console.log(FileData.name)} */}

                    {FileData?.name != undefined
                      ? FileData?.name
                      : "เลือกเอกสารที่ต้องการอัพโหลด"}
                  </Button>
                </label>
              </div>
              <div style={{ display: "flex", marginTop: 10 }}>
                {FileData?.name != undefined ? (
                  <TextField
                    name="remarkFile"
                    label="Remark *"
                    variant="outlined"
                    placeholder="Remark *"
                    onChange={(e) => setRemarkFile(e.target.value)}
                    style={{ width: "100%", marginRight: 5 }}
                    InputLabelProps={{ shrink: true }}
                    value={RemarkFile}
                  />
                ) : null}
                <Button
                  variant="contained"
                  style={{ marginLeft: "10px" }}
                  color="success"
                  component="span"
                  onClick={handleFileUpload}
                >
                  <FileUploadIcon /> Upload
                </Button>
              </div>
              <div>
                {myFile?.length > 0 ? (
                  <div>
                    <h6
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      {" "}
                      ไฟล์ของคุณ
                    </h6>
                    <TableContainer
                      sx={{
                        marginTop: 2,
                        marginBottom: 2,
                        maxHeight: "50vh",
                        overflow: "auto",
                      }}
                    >
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center" width="5%">
                              #
                            </TableCell>
                            <TableCell align="center">ชื่อไฟล์</TableCell>
                            <TableCell align="center" width="50%">
                              ลบ
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        {myFile?.map((data, index) => {
                          return (
                            <TableBody key={index}>
                              <TableCell align="center">{index + 1}</TableCell>
                              <TableCell align="center">
                                {data.remark}
                                <br />
                                <a
                                  href={
                                    process.env.REACT_APP_BASE_API + data.path
                                  }
                                  target="_blank"
                                >
                                  <font color="grey">{data.name}</font>
                                </a>
                              </TableCell>

                              <TableCell align="center">
                                <Button
                                  variant="contained"
                                  style={{
                                    color: "white",
                                    backgroundColor: "#FF0000",
                                  }}
                                  onClick={async () => {
                                    const MySwal = withReactContent(Swal);
                                    MySwal.fire({
                                      title: "คุณกำลังลบไฟล์?",
                                      text: "คุณกำลังต้องการที่จะลบไฟล์ใช่หรือไม่!",
                                      icon: "info",
                                      showCancelButton: true,
                                      confirmButtonColor: "#3085d6",
                                      cancelButtonColor: "#d33",
                                      confirmButtonText: "ใช่ !",
                                      cancelButtonText: "ไม่",
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        const params = {
                                          id: data.id,
                                        };
                                        api
                                          .post(
                                            "api/saleorder/file/delete",
                                            params
                                          )
                                          .then((respose) => {
                                            const MySwal =
                                              withReactContent(Swal);

                                            MySwal.fire({
                                              icon: "success",
                                              didOpen: () => {
                                                MySwal.clickConfirm();
                                              },
                                            }).then(() => {
                                              return MySwal.fire(
                                                "สำเร็จ!",
                                                "ลบไฟล์สำเร็จ !",
                                                "success"
                                              );
                                            });
                                            getMyFile();
                                          });
                                      }
                                    });
                                  }}
                                >
                                  ลบ
                                </Button>
                              </TableCell>
                            </TableBody>
                          );
                        })}
                      </Table>
                    </TableContainer>
                  </div>
                ) : null}
              </div>
            </TabPanel>
            <TabPanel value="7">
            
              <Box
                sx={{
                  height: 400,
                  width: "100%",
                  marginTop: "10px",
                  "& .Active": {
                    color: "#28A745",
                  },
                  "& .Inactive": {
                    color: "#F53C56",
                  },
                }}
              >
              
                <DataGrid
                  getRowId={(r) => r.SalesOrderLogId}
                  rows={log_data}
                  columns={columnsLog}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  hideFooterSelectedRowCount
                  disableColumnFilter
                  disableColumnMenu
                  getCellClassName={(params) => {
                    if (params.field === "Status") {
                      return params.value == 1 ? "Active" : "Inactive";
                    }
                  }}
                />
              </Box>
            </TabPanel>
          </TabContext>
        </Card>

        <Dialog
          open={MT_CNTR_AT_CY_STL}
          onClose={() => handleClose}
          aria-labelledby="responsive-dialog-title"
          fullWidth="lg"
        >
          <DialogTitle id="responsive-dialog-title">
            {
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                ADD ROW
              </Typography>
            }
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <h5 className="textcolordarkblue">MT CNTR AT CY STL</h5>
            </DialogContentText>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth sx={{ ml: "5px" }}>
                  <InputLabel>Request STL Truck</InputLabel>
                  <Select
                    name="req_stl_truck"
                    label="Request STL Truck "
                    value={req_stl_truck}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => setReq_stel_truck(e.target.value)}
                  >
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  margin="dense"
                  label="VOYAGE NO."
                  fullWidth
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setVoyage_no(e.target.value)}
                  value={voyage_no}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  margin="dense"
                  label="MT ETA ICD-TS"
                  fullWidth
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setMt_eta(e.target.value)}
                  value={mt_eta}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  margin="dense"
                  label="PICK-UP DATE"
                  InputLabelProps={{ shrink: true }}
                  type="date"
                  fullWidth
                  variant="standard"
                  onChange={(e) => setPickupDate(e.target.value)}
                  value={pickUpDate}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              sx={{ width: 80 }}
              type="button"
              variant="outlined"
              style={{
                color: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              onClick={() => handleClose()}
            >
              close
            </Button>
            <Button
              sx={{ width: 80 }}
              type="submit"
              variant="contained"
              style={{
                background: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              //   disabled={Submitting}
              onClick={() => confirm_mt_stl()}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={STUFFING_PLAN}
          onClose={() => handleClose}
          aria-labelledby="responsive-dialog-title"
          fullWidth="lg"
        >
          <DialogTitle id="responsive-dialog-title">
            {
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                ADD ROW
              </Typography>
            }
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <h5 className="textcolordarkblue">STUFFING_PLAN</h5>
            </DialogContentText>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  margin="dense"
                  label="DATE"
                  fullWidth
                  type="date"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setspDate(e.target.value)}
                  value={spDate}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel>Factory</InputLabel>
                  <Select
                    name="spFactory"
                    label="COMMODITY"
                    value={spFactory}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => setspFactory(e.target.value)}
                  >
                    <MenuItem value="" disabled>
                      <em>เลือก Factory </em>
                    </MenuItem>
                    {spFactory_fetch_Data.map((option, index) => {
                      return (
                        <MenuItem key={index} value={option.FactoryName}>
                          {option.FactoryName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              sx={{ width: 80 }}
              type="button"
              variant="outlined"
              style={{
                color: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              onClick={() => handleClose()}
            >
              close
            </Button>
            <Button
              sx={{ width: 80 }}
              type="submit"
              variant="contained"
              style={{
                background: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              //   disabled={Submitting}
              onClick={() => confirm_stuffing_plan()}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={LADEN_CNTR}
          onClose={() => handleClose}
          aria-labelledby="responsive-dialog-title"
          fullWidth="lg"
        >
          <DialogTitle id="responsive-dialog-title">
            {
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                ADD ROW
              </Typography>
            }
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <h5 className="textcolordarkblue">LADEN CNTR</h5>
            </DialogContentText>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth sx={{ ml: "5px" }}>
                  <InputLabel>Choose</InputLabel>
                  <Select
                    name="laden_choose"
                    label="Request STL Truck "
                    value={laden_Choose}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => setLaden_Choose(e.target.value)}
                  >
                    <MenuItem value="" disabled>
                      เลือกประเภทขนส่ง
                    </MenuItem>
                    {groupData.map((option, index) => {
                      return (
                        <MenuItem key={index} value={option.GroupId}>
                          {option.GroupName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  margin="dense"
                  label="VOYAGE NO."
                  fullWidth
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setLaden_voyNo(e.target.value)}
                  value={laden_voyNo}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  margin="dense"
                  label="LADEN ETD ICD-TS (DATE)"
                  fullWidth
                  variant="standard"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setLaden_etdDate(e.target.value)}
                  value={laden_etdDate}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              sx={{ width: 80 }}
              type="button"
              variant="outlined"
              style={{
                color: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              onClick={() => handleClose()}
            >
              close
            </Button>
            <Button
              sx={{ width: 80 }}
              type="submit"
              variant="contained"
              style={{
                background: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              //   disabled={Submitting}
              onClick={() => confirm_laden()}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={open} onClose={handleDialogClose}>
          <DialogTitle>Cancel</DialogTitle>
          <DialogContent>
            <DialogContentText>โปรดแจ้งสาเหตุในการยกเลิก.</DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              label="Remark"
              value={remarkStatus}
              onChange={(e) => setRemarkStatus(e.target.value)}
              fullWidth
              required
              variant="standard"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>Cancel</Button>
            <Button
              onClick={() => {
                if (remarkStatus !== "") {
                  const datastatuscancel = {
                    id: id,
                    statusCancel: 0,
                    remark: remarkStatus,
                    ModId: EmpId,
                  };
                  api
                    .post("api/saleorder/change", datastatuscancel)
                    .then((respose) => {
                      const MySwal = withReactContent(Swal);

                      MySwal.fire({
                        icon: "success",
                        didOpen: () => {
                          MySwal.clickConfirm();
                        },
                      }).then(() => {
                        return MySwal.fire(
                          "สำเร็จ!",
                          "เปลี่ยนสถานะสำเร็จ !",
                          "success"
                        );
                      });
                      getSaleOrder_Data();
                      setDialogOpen(false);
                      setRemarkStatus("");
                    })
                    .catch((err) => {
                      console.log(err);
                      setDialogOpen(false);
                    });
                } else {
                  alert("กรุณากรอกเหตุผล");
                }
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={activeopen} onClose={handleDialogActiveClose}>
          <DialogTitle>Active</DialogTitle>
          <DialogContent>
            <DialogContentText>
              โปรดแจ้งสาเหตุในการเปิดใช้งานอีกครั้ง.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              label="Remark"
              value={remarkStatus}
              onChange={(e) => setRemarkStatus(e.target.value)}
              fullWidth
              required
              variant="standard"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogActiveClose}>Cancel</Button>
            <Button
              onClick={() => {
                if (remarkStatus !== "") {
                  const datastatuscancel = {
                    id: id,
                    statusCancel: 1,
                    remark: remarkStatus,
                    ModId: EmpId,
                  };
                  api
                    .post("api/saleorder/change", datastatuscancel)
                    .then((respose) => {
                      const MySwal = withReactContent(Swal);

                      MySwal.fire({
                        icon: "success",
                        didOpen: () => {
                          MySwal.clickConfirm();
                        },
                      }).then(() => {
                        return MySwal.fire(
                          "สำเร็จ!",
                          "เปลี่ยนสถานะสำเร็จ !",
                          "success"
                        );
                      });
                      getSaleOrder_Data();
                      setDialogActiveOpen(false);
                      setRemarkStatus("");
                    })
                    .catch((err) => {
                      console.log(err);
                      setDialogActiveOpen(false);
                    });
                } else {
                  alert("กรุณากรอกเหตุผล");
                }
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        {/* Dialog Voy */}
        <Dialog
          open={Dialog_Voy_Fetch}
          onClose={() => setDialog_Voy(false)}
          maxWidth="xl"
        // sx={{
        //   "& .MuiDialog-container": {
        //     "& .MuiPaper-root": {
        //       width: "100%",
        //       maxWidth: "800px", // Set your width here
        //     },
        //   },
        // }}
        >
          <DialogTitle id="responsive-dialog-title">
            {
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Select
              </Typography>
            }
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <h5 className="textcolordarkblue">Voyage No.</h5>
            </DialogContentText>
            <div style={{ height: "600px", width: "100%" }}>
              <Grid
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <SearchData name={voy_fetch} onsetData={setVoy_DataFilter} />
              </Grid>

              {/* <DataGrid
                getRowId={(r) => r.id}
                rows={voy_dataFilter}
                columns={columns_voy}
                style={{ height: "400px" }}
                pageSize={5}
                rowsPerPageOptions={[5]}
                hideFooterSelectedRowCount
                disableColumnFilter
                disableColumnMenu
              /> */}
              <Box sx={{ display: "flex" }}>
                <DataGrid
                  getRowId={(r) => r.id}
                  rows={voy_dataFilter?.voyIn}
                  columns={columns_voy_In}
                  style={{ height: "500px" }}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  hideFooterSelectedRowCount
                  disableColumnFilter
                  disableColumnMenu
                  fullWidth
                  sx={{ width: "750px" }}
                />

                <DataGrid
                  getRowId={(r) => r.id}
                  rows={voy_dataFilter?.voyOut}
                  columns={columns_voy_Out}
                  style={{ height: "500px" }}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  hideFooterSelectedRowCount
                  disableColumnFilter
                  disableColumnMenu
                  fullWidth
                  sx={{ width: "750px" }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  marginTop: "20px",
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ marginRight: "15px" }}>
                  VOY IN: {voy_no_select}
                </Typography>
                <Typography>VOY OUT: {voy_no_select_Out}</Typography>
              </Box>
            </div>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              sx={{ width: 80 }}
              type="button"
              variant="outlined"
              style={{
                color: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              onClick={() => setDialog_Voy(false)}
            >
              close
            </Button>
            {voy_no_select !== "" && voy_no_select_Out !== "" ? (
              <Button
                sx={{ width: 80 }}
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={() => {
                  setDialog_Voy(false);
                  // setLaden_voyNo(voy_no_select_Out)
                  // setLADEN_CNTR(true)
                  const data = {
                    voyNo: voy_no_select_Out,
                    etdDate: getETAIn,
                    choose: chooseText,
                    status: 1,
                    ModId: EmpId,
                  };
                  setLadenData([...laden_data, data]);
                }}
              >
                confirm
              </Button>
            ) : (
              ""
            )}
          </DialogActions>
        </Dialog>
      </LocalizationProvider>
    </div>
  );
}
